import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';

import type { Body_login_login_access_token,LoginResponse,Message,NewPassword,Body_requests_request_upload_csv,Body_requests_request_upload_csv_no_partner_rules,RequestCreate,Input,AnnieCreate,NoteCreate,NotePublicBasic,NotesBatchCreate,NotesBatchResult,NotesPublic,ReferralNotificationOptions,Body_uploads_upload_files,AiClaimsDashboardSummaryPublic,AiClaimsReferralIntakeRequest,AiClaimsReferralIntakeResponse,Body_aiclaims_audit_batch_endpoint,Body_aiclaims_submit_call_analysis_job,Body_aiclaims_upload_call_analysis,CallAnalysisJobPublic,CallAnalysisJobsPublic,CallAnalysisWorkflowsPublic,CallAuditBatchesPublic,CallAuditConfigPublic,CallAuditConfigUpsert,CallAuditRerunRequest,WorkflowBuilderCommitRequest,WorkflowBuilderCommitResult,WorkflowBuilderOutputPayload,WorkflowBuilderOutputRequest,WorkflowBuilderPromptRequest,WorkflowBuilderWorkflowPayload,WorkflowBuilderWorkflowRequest,WorkflowCardsPublic,WorkflowPromptPayload,ActiveBrandBody,ApiKeyIssueRequest,ApiKeyMetadataPublic,ApiKeyMetadataUpdateRequest,ApiKeysMetadataPublic,ServiceAccountCreateRequest,UpdatePassword,UserCreate,UserPublic,UserRegister,UsersPublic,UserUpdate,UserUpdateMe,AgentRunPublic,AgentRunsPublic,AgentRunSummary,RunInspectorResponse,app__api__routes__workflow_definitions__WorkflowDefinitionPublic,CloneRequest,CompareRequest,CreateRequest,EditRequest,RegisteredEngineListResponse,TestRequest,WorkflowListResponse,WorkflowBillingEventPublic,WorkflowBillingEventsPublic,WorkflowBillingEventUpdate,PartnerCreate,PartnerPublic,PartnersPublic,PartnerUpdate,MyPagesResponse,PermissionCatalogResponse,InsurerCreate,InsurerPublic,InsurersPublic,InsurerUpdate,Partner_RuleCreate,Partner_RulePublic,Partner_RulesPublic,Partner_RuleUpdate,Circs_GradeCreate,Circs_GradePublic,Circs_GradesPublic,Circs_GradeUpdate,ClaimCreate,ClaimPublic,ClaimsPublic,ClaimUpdate,ComplaintCreate,ComplaintPublic,ComplaintsPublic,ComplaintUpdate,Referral_AllocationCreate,Referral_AllocationPublic,Referral_AllocationReallocate,Referral_AllocationsPublic,Referral_AllocationUpdate,Body_referrals_create_bulk_summary_operation,BulkOperationPublic,ClaimSummaryDetailPublic,ClaimSummaryPublic,ReferralCreate,ReferralPublic,ReferralsPublic,ReferralUpdate,ClaimSummaryRecentRunsPublic,SummaryFeedbackBody,Source_RateCreate,Source_RatePublic,Source_RatesPublic,Source_RateUpdate,Supplier_RateCreate,Supplier_RatePublic,Supplier_RatesPublic,Supplier_RateUpdate,Veh_GroupCreate,Veh_GroupPublic,Veh_GroupsPublic,Veh_GroupUpdate,AuthoritiesPublic,AuthorityCreate,AuthorityPublic,AuthorityUpdate,User_PartnerCreate,User_PartnerPublic,User_PartnersPublic,User_PartnerUpdate,Role_AllocationCreate,Role_AllocationPublic,Role_AllocationsPublic,Role_AllocationUpdate,RoleCreate,RolePublic,RolesPublic,RoleUpdate,Role_PermissionCreate,Role_PermissionPublic,Role_PermissionsPublic,Role_PermissionUpdate,Body_calls_incoming_call,InvoiceLinePublic,InvoicePublic,PartnerApiBillingConfigCreate,PartnerApiBillingConfigPublic,PartnerApiBillingConfigsPublic,PartnerApiBillingConfigUpdate,RequestLogsPublic,WorkflowRateConfigCreate,WorkflowRateConfigPublic,WorkflowRateConfigsPublic,WorkflowRateConfigUpdate,ProfilerStats,Body_edge_import_upload_edge_csv,AccessRequestData,SwitchCompanyRequest,XeroSeedRequest,AIPromptConfigCreate,AIPromptConfigPublic,AIPromptConfigsPublic,AIPromptConfigUpdate,AIPromptDraftUpdate,AIPromptRevisionCreate,AIPromptSlotsPublic,BatchPostprocessorOptions,ReportTemplateCreate,ReportTemplatePublic,ReportTemplatesPublic,ReportTemplateUpdate,BulkOperationConfigCreate,BulkOperationConfigPublic,BulkOperationConfigsPublic,BulkOperationConfigUpdate,RateLimitConfigCreate,RateLimitConfigPublic,RateLimitConfigsPublic,RateLimitConfigUpdate,AppSettingCreate,AppSettingPublic,AppSettingsPublic,AppSettingUpdate,PrivacyPurgeResponse,PrivacyRehydrateRequest,PrivacyRehydrateResponse,MetabaseReportScheduleCreate,MetabaseReportSchedulePublic,MetabaseReportSchedulesPublic,MetabaseReportScheduleUpdate,MetabaseReportCatalogCreate,MetabaseReportCatalogPublic,MetabaseReportCatalogsPublic,MetabaseReportCatalogUpdate,MetabaseEmbedTokenPublic,MetabaseEmbedTokenRequest,MetabaseReportCatalogAvailablePublic,PerformanceMetric,SecurityTestResultCreate,SecurityTestResultPublic,SecurityTestResultsPublic,TaskScheduleConfigCreate,TaskScheduleConfigPublic,TaskScheduleConfigsPublic,TaskScheduleConfigUpdate,TaskScheduleExecutionPublic,TaskScheduleExecutionsPublic,WorkflowRunDetailPublic,WorkflowRunsListPublic,PartnerIssueRollupPublic } from './models';

export type TDataLoginAccessToken = {
                formData: Body_login_login_access_token

            }
export type TDataCompleteSessionHandoff = {
                next?: string | null
token: string

            }
export type TDataRecoverPassword = {
                email: string

            }
export type TDataResetPassword = {
                requestBody: NewPassword

            }
export type TDataRecoverPasswordHtmlContent = {
                email: string

            }
export type TDataStartSessionHandoff = {
                brand: string
next?: string | null

            }

export class LoginService {

	/**
	 * Login Access Token
	 * OAuth2 compatible token login, get an access token for future requests, set in an HttpOnly cookie.
	 * @returns LoginResponse Successful Response
	 * @throws ApiError
	 */
	public static loginAccessToken(data: TDataLoginAccessToken): CancelablePromise<LoginResponse> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/login/access-token',
			formData: formData,
			mediaType: 'application/x-www-form-urlencoded',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Complete Session Handoff
	 * Exchange a one-time handoff token for auth cookies on the current host.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static completeSessionHandoff(data: TDataCompleteSessionHandoff): CancelablePromise<unknown> {
		const {
next,
token,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/login/session-handoff/complete',
			query: {
				token, next
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Logout
	 * Clear the access token cookie to log out the user.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static logout(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/logout/',
		});
	}

	/**
	 * Check Auth
	 * Endpoint to verify if the user is authenticated based on the access token.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static checkAuth(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/check-auth/',
		});
	}

	/**
	 * Recover Password
	 * Password Recovery
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static recoverPassword(data: TDataRecoverPassword): CancelablePromise<Message> {
		const {
email,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/password-recovery/{email}',
			path: {
				email
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Reset Password
	 * Reset password
 *
 * SECURITY FIX (AUTH-VULN-06): Token replay prevention - each token can only be used once.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static resetPassword(data: TDataResetPassword): CancelablePromise<Message> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/reset-password/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Recover Password Html Content
	 * HTML Content for Password Recovery
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static recoverPasswordHtmlContent(data: TDataRecoverPasswordHtmlContent): CancelablePromise<string> {
		const {
email,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/password-recovery-html-content/{email}',
			path: {
				email
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Start Session Handoff
	 * Create a one-time handoff token and redirect to the target portal host.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static startSessionHandoff(data: TDataStartSessionHandoff): CancelablePromise<unknown> {
		const {
brand,
next,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/login/session-handoff/start',
			query: {
				brand, next
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Flower Auth
	 * Simplified endpoint for Flower authentication.
 * Note: ForwardAuth middleware has been removed to fix login issues.
 * This endpoint is kept for compatibility but returns a simple success response.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static flowerAuth(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/flower-auth/',
		});
	}

	/**
	 * Get Csrf Token
	 * Generate and return a CSRF token for frontend forms.
 * The token is also set as a cookie for double submit protection.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getCsrfToken(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/csrf-token/',
		});
	}

}

export type TDataRequestUploadCsv = {
                formData: Body_requests_request_upload_csv

            }
export type TDataCreateRequest = {
                requestBody: RequestCreate

            }
export type TDataRequestUploadCsvNoPartnerRules = {
                formData: Body_requests_request_upload_csv_no_partner_rules

            }
export type TDataManualRequestNoPartnerRules = {
                requestBody: RequestCreate

            }

export class RequestsService {

	/**
	 * Request Upload Csv
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static requestUploadCsv(data: TDataRequestUploadCsv): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/requests/import/',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Request
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createRequest(data: TDataCreateRequest): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/requests/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Request Upload Csv No Partner Rules
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static requestUploadCsvNoPartnerRules(data: TDataRequestUploadCsvNoPartnerRules): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/requests/import_no_rules/',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Manual Request No Partner Rules
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static manualRequestNoPartnerRules(data: TDataManualRequestNoPartnerRules): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/requests/manual_request_no_rules/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataLiabilityScoreFast = {
                requestBody: Input

            }

export class AnniequickscoreService {

	/**
	 * Liability Score Fast
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static liabilityScoreFast(data: TDataLiabilityScoreFast): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/anniequickscore/score-fast',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadAnnies = {
                requestBody: AnnieCreate

            }

export class AnniesService {

	/**
	 * Read Annies
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readAnnies(data: TDataReadAnnies): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/annies/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Annies Voice
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readAnniesVoice(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/annies/voice',
		});
	}

}



export class SettingsPublicService {

	/**
	 * Get Feature Flags
	 * Return whitelisted feature flags for the current environment.
 *
 * This endpoint is intentionally public and must only expose non-sensitive
 * flags. If you need a new flag here, ensure it's safe for public access.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getFeatureFlags(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/settings/feature-flags',
		});
	}

}

export type TDataAddNote = {
                referralId: number
requestBody: NoteCreate

            }
export type TDataGetNotes = {
                referralId: number

            }
export type TDataGetNotificationOptions = {
                referralId: number

            }
export type TDataAddNotesBatch = {
                requestBody: NotesBatchCreate

            }
export type TDataUpdateNote = {
                note: string
noteId: number

            }
export type TDataDeleteNote = {
                noteId: number

            }
export type TDataAddComplaintNote = {
                complaintId: number
requestBody: NoteCreate

            }
export type TDataGetComplaintNotes = {
                complaintId: number

            }

export class ReferralNotesService {

	/**
	 * Add Note
	 * @returns NotePublicBasic Successful Response
	 * @throws ApiError
	 */
	public static addNote(data: TDataAddNote): CancelablePromise<NotePublicBasic> {
		const {
referralId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_notes/{referral_id}/notes',
			path: {
				referral_id: referralId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Notes
	 * @returns NotesPublic Successful Response
	 * @throws ApiError
	 */
	public static getNotes(data: TDataGetNotes): CancelablePromise<NotesPublic> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_notes/{referral_id}/notes',
			path: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Notification Options
	 * Get available partners for email notifications on note creation.
	 * @returns ReferralNotificationOptions Successful Response
	 * @throws ApiError
	 */
	public static getNotificationOptions(data: TDataGetNotificationOptions): CancelablePromise<ReferralNotificationOptions> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_notes/{referral_id}/notification-options',
			path: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Add Notes Batch
	 * @returns NotesBatchResult Successful Response
	 * @throws ApiError
	 */
	public static addNotesBatch(data: TDataAddNotesBatch): CancelablePromise<NotesBatchResult> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_notes/notes/batch',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Note
	 * Update a note.
 *
 * SECURITY (AUTHZ-VULN-12): Users can only update notes they created,
 * unless they are a System Administrator.
	 * @returns NotePublicBasic Successful Response
	 * @throws ApiError
	 */
	public static updateNote(data: TDataUpdateNote): CancelablePromise<NotePublicBasic> {
		const {
note,
noteId,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/referral_notes/notes/{note_id}',
			path: {
				note_id: noteId
			},
			query: {
				note
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Note
	 * Delete a note.
 *
 * SECURITY (AUTHZ-VULN-12): Users can only delete notes they created,
 * unless they are a System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteNote(data: TDataDeleteNote): CancelablePromise<unknown> {
		const {
noteId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/referral_notes/notes/{note_id}',
			path: {
				note_id: noteId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Add Complaint Note
	 * @returns NotePublicBasic Successful Response
	 * @throws ApiError
	 */
	public static addComplaintNote(data: TDataAddComplaintNote): CancelablePromise<NotePublicBasic> {
		const {
complaintId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_notes/complaints/{complaint_id}/notes',
			path: {
				complaint_id: complaintId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Complaint Notes
	 * @returns NotesPublic Successful Response
	 * @throws ApiError
	 */
	public static getComplaintNotes(data: TDataGetComplaintNotes): CancelablePromise<NotesPublic> {
		const {
complaintId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_notes/complaints/{complaint_id}/notes',
			path: {
				complaint_id: complaintId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataUploadFiles = {
                formData: Body_uploads_upload_files

            }
export type TDataDownloadClaimFile = {
                fileId: number
referralId: number

            }
export type TDataGetDownloadStatus = {
                referralId: number

            }
export type TDataDownloadMultipleFiles = {
                referralId: number
requestBody: Array<number>

            }

export class UploadsService {

	/**
	 * Upload Files
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static uploadFiles(data: TDataUploadFiles): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/uploads/upload_files/',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Download Claim File
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static downloadClaimFile(data: TDataDownloadClaimFile): CancelablePromise<unknown> {
		const {
fileId,
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/uploads/download',
			query: {
				file_id: fileId, referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Download Status
	 * Get download status for all files in a referral for the current user.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getDownloadStatus(data: TDataGetDownloadStatus): CancelablePromise<unknown> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/uploads/download-status',
			query: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Download Multiple Files
	 * Download multiple files as a zip archive.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static downloadMultipleFiles(data: TDataDownloadMultipleFiles): CancelablePromise<unknown> {
		const {
referralId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/uploads/download-multiple',
			query: {
				referral_id: referralId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataSendUnlockEmail = {
                email: string
requestBody?: Array<string> | null

            }
export type TDataUnlockAccount = {
                requestBody?: Array<string> | null
token: string

            }

export class AccountUnlockServiceService {

	/**
	 * Send Unlock Email
	 * Send account unlock email.
 *
 * SECURITY FIXES:
 * - AUTH-VULN-01: Strict rate limiting (3 per 15 min) to prevent abuse
 * - AUTH-VULN-04: Non-enumerating response - same message whether user exists or not
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static sendUnlockEmail(data: TDataSendUnlockEmail): CancelablePromise<unknown> {
		const {
email,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/accountunlock/send-unlock-email/',
			query: {
				email
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Unlock Account
	 * Unlock account using token from email.
 *
 * SECURITY FIXES:
 * - AUTH-VULN-02: Rate limiting (5 per hour) to prevent brute-force attacks
 * - AUTH-VULN-07: Token replay prevention - each token can only be used once
	 * @throws ApiError
	 */
	public static unlockAccount(data: TDataUnlockAccount): CancelablePromise<void> {
		const {
requestBody,
token,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/accountunlock/unlock-account',
			query: {
				token
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				307: `Successful Response`,
				422: `Validation Error`,
			},
		});
	}

}

export type TDataCreateReferralIntake = {
                requestBody: AiClaimsReferralIntakeRequest

            }
export type TDataGetReferralIntakeOperation = {
                operationId: number

            }
export type TDataGetIntakeSummaryStatus = {
                intakeId: number

            }
export type TDataGetAiclaimsDashboardSummary = {
                fromDate?: string | null
toDate?: string | null

            }
export type TDataGetAiclaimsWorkflowCards = {
                fromDate?: string | null
toDate?: string | null

            }
export type TDataListCallAnalysisWorkflows = {
                partnerId?: number | null

            }
export type TDataUploadCallAnalysis = {
                formData: Body_aiclaims_upload_call_analysis

            }
export type TDataListCallAnalysisJobs = {
                limit?: number
partnerId?: number | null
skip?: number

            }
export type TDataGetCallAnalysisJob = {
                jobId: number

            }
export type TDataSubmitCallAnalysisJob = {
                jobId: number
requestBody: Body_aiclaims_submit_call_analysis_job

            }
export type TDataAuditBatchEndpoint = {
                formData: Body_aiclaims_audit_batch_endpoint

            }
export type TDataAuditRerunEndpoint = {
                requestBody: CallAuditRerunRequest

            }
export type TDataGetAuditBatchEndpoint = {
                batchId: string

            }
export type TDataListAuditBatchesEndpoint = {
                limit?: number
partnerId?: number | null
skip?: number

            }
export type TDataDownloadCallAuditOutput = {
                channel: string
runId: string

            }
export type TDataGetCallAuditConfigEndpoint = {
                partnerId: number

            }
export type TDataUpsertCallAuditConfigEndpoint = {
                partnerId: number
requestBody: CallAuditConfigUpsert

            }
export type TDataGeneratePrompt = {
                requestBody: WorkflowBuilderPromptRequest

            }
export type TDataGenerateWorkflow = {
                requestBody: WorkflowBuilderWorkflowRequest

            }
export type TDataGenerateOutput = {
                requestBody: WorkflowBuilderOutputRequest

            }
export type TDataCommitWorkflow = {
                requestBody: WorkflowBuilderCommitRequest

            }

export class AiclaimsService {

	/**
	 * Create Referral Intake
	 * Accept partner-facing non-owned referrals into intake staging and queue async processing.
	 * @returns AiClaimsReferralIntakeResponse Successful Response
	 * @throws ApiError
	 */
	public static createReferralIntake(data: TDataCreateReferralIntake): CancelablePromise<AiClaimsReferralIntakeResponse> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referrals/report-data',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Referral Intake Operation
	 * Poll operation-level status for referral intake submissions.
	 * @returns AiClaimsReferralIntakeResponse Successful Response
	 * @throws ApiError
	 */
	public static getReferralIntakeOperation(data: TDataGetReferralIntakeOperation): CancelablePromise<AiClaimsReferralIntakeResponse> {
		const {
operationId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/report-data/operations/{operation_id}',
			path: {
				operation_id: operationId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Intake Summary Status
	 * Poll summary status using intake ID for partner-facing workflows.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getIntakeSummaryStatus(data: TDataGetIntakeSummaryStatus): CancelablePromise<Record<string, unknown>> {
		const {
intakeId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/report-data/{intake_id}/summary-status',
			path: {
				intake_id: intakeId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Aiclaims Dashboard Summary
	 * @returns AiClaimsDashboardSummaryPublic Successful Response
	 * @throws ApiError
	 */
	public static getAiclaimsDashboardSummary(data: TDataGetAiclaimsDashboardSummary = {}): CancelablePromise<AiClaimsDashboardSummaryPublic> {
		const {
fromDate,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/dashboard-summary',
			query: {
				fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Aiclaims Workflow Cards
	 * @returns WorkflowCardsPublic Successful Response
	 * @throws ApiError
	 */
	public static getAiclaimsWorkflowCards(data: TDataGetAiclaimsWorkflowCards = {}): CancelablePromise<WorkflowCardsPublic> {
		const {
fromDate,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/workflow-cards',
			query: {
				fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Call Analysis Workflows
	 * @returns CallAnalysisWorkflowsPublic Successful Response
	 * @throws ApiError
	 */
	public static listCallAnalysisWorkflows(data: TDataListCallAnalysisWorkflows = {}): CancelablePromise<CallAnalysisWorkflowsPublic> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-analysis/workflows',
			query: {
				partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Upload Call Analysis
	 * @returns CallAnalysisJobPublic Successful Response
	 * @throws ApiError
	 */
	public static uploadCallAnalysis(data: TDataUploadCallAnalysis): CancelablePromise<CallAnalysisJobPublic> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/call-analysis/upload',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Call Analysis Jobs
	 * @returns CallAnalysisJobsPublic Successful Response
	 * @throws ApiError
	 */
	public static listCallAnalysisJobs(data: TDataListCallAnalysisJobs = {}): CancelablePromise<CallAnalysisJobsPublic> {
		const {
limit = 20,
partnerId,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-analysis/jobs',
			query: {
				skip, limit, partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Call Analysis Job
	 * @returns CallAnalysisJobPublic Successful Response
	 * @throws ApiError
	 */
	public static getCallAnalysisJob(data: TDataGetCallAnalysisJob): CancelablePromise<CallAnalysisJobPublic> {
		const {
jobId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-analysis/jobs/{job_id}',
			path: {
				job_id: jobId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Submit Call Analysis Job
	 * Queue a transcribed job into the aiclaims intake pipeline for a given workflow.
	 * @returns CallAnalysisJobPublic Successful Response
	 * @throws ApiError
	 */
	public static submitCallAnalysisJob(data: TDataSubmitCallAnalysisJob): CancelablePromise<CallAnalysisJobPublic> {
		const {
jobId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/call-analysis/jobs/{job_id}/submit',
			path: {
				job_id: jobId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Audit Batch Endpoint
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static auditBatchEndpoint(data: TDataAuditBatchEndpoint): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/call-auditing/audit/batch',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Audit Rerun Endpoint
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static auditRerunEndpoint(data: TDataAuditRerunEndpoint): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/call-auditing/audit/rerun',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Audit Batch Endpoint
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getAuditBatchEndpoint(data: TDataGetAuditBatchEndpoint): CancelablePromise<unknown> {
		const {
batchId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-auditing/audit/batch/{batch_id}',
			path: {
				batch_id: batchId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Audit Batches Endpoint
	 * @returns CallAuditBatchesPublic Successful Response
	 * @throws ApiError
	 */
	public static listAuditBatchesEndpoint(data: TDataListAuditBatchesEndpoint = {}): CancelablePromise<CallAuditBatchesPublic> {
		const {
limit = 50,
partnerId,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-auditing/audit/batches',
			query: {
				partnerId, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Download Call Audit Output
	 * Stream a rendered call-audit output (pdf/csv/xlsx) for a run/batch.
	 * @returns any Successful Response
	 * @throws ApiError
	 */
	public static downloadCallAuditOutput(data: TDataDownloadCallAuditOutput): CancelablePromise<any> {
		const {
channel,
runId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-auditing/audit/{run_id}/download',
			path: {
				run_id: runId
			},
			query: {
				channel
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Call Audit Config Endpoint
	 * Get the per-partner call-audit binding (review agent + report template).
	 * @returns CallAuditConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static getCallAuditConfigEndpoint(data: TDataGetCallAuditConfigEndpoint): CancelablePromise<CallAuditConfigPublic> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/aiclaims/call-auditing/config',
			query: {
				partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Upsert Call Audit Config Endpoint
	 * Create or update the per-partner call-audit binding. Superuser only.
	 * @returns CallAuditConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static upsertCallAuditConfigEndpoint(data: TDataUpsertCallAuditConfigEndpoint): CancelablePromise<CallAuditConfigPublic> {
		const {
partnerId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/aiclaims/call-auditing/config',
			query: {
				partnerId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Prompt
	 * Generate an editable AI prompt draft payload from admin intent.
	 * @returns WorkflowPromptPayload Successful Response
	 * @throws ApiError
	 */
	public static generatePrompt(data: TDataGeneratePrompt): CancelablePromise<WorkflowPromptPayload> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/workflow-builder/generate-prompt',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Workflow
	 * Generate editable workflow_definition JSON from prompt metadata.
	 * @returns WorkflowBuilderWorkflowPayload Successful Response
	 * @throws ApiError
	 */
	public static generateWorkflow(data: TDataGenerateWorkflow): CancelablePromise<WorkflowBuilderWorkflowPayload> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/workflow-builder/generate-workflow',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Output
	 * Generate editable ReportTemplate content for workflow output.
	 * @returns WorkflowBuilderOutputPayload Successful Response
	 * @throws ApiError
	 */
	public static generateOutput(data: TDataGenerateOutput): CancelablePromise<WorkflowBuilderOutputPayload> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/workflow-builder/generate-output',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Commit Workflow
	 * Create live prompt/workflow/template artifacts and a disabled schedule.
	 * @returns WorkflowBuilderCommitResult Successful Response
	 * @throws ApiError
	 */
	public static commitWorkflow(data: TDataCommitWorkflow): CancelablePromise<WorkflowBuilderCommitResult> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/aiclaims/workflow-builder/commit',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataSetActiveBrandMe = {
                requestBody: ActiveBrandBody

            }
export type TDataReadUsers = {
                limit?: number
skip?: number

            }
export type TDataCreateUser = {
                requestBody: UserCreate

            }
export type TDataUpdateUserMe = {
                requestBody: UserUpdateMe

            }
export type TDataUpdatePasswordMe = {
                requestBody: UpdatePassword

            }
export type TDataRegisterUser = {
                requestBody: UserRegister

            }
export type TDataReadServiceAccounts = {
                limit?: number
skip?: number

            }
export type TDataCreateServiceAccount = {
                requestBody: ServiceAccountCreateRequest

            }
export type TDataReadUserById = {
                userId: number

            }
export type TDataUpdateUser = {
                requestBody: UserUpdate
userId: number

            }
export type TDataDeleteUser = {
                userId: number

            }
export type TDataGetLoginHistory = {
                userId: number

            }
export type TDataGenerateApiKeyForUser = {
                requestBody?: ApiKeyIssueRequest | null
userId: number

            }
export type TDataListApiKeysForUser = {
                userId: number

            }
export type TDataUpdateApiKeyForUser = {
                apiKeyId: number
requestBody: ApiKeyMetadataUpdateRequest
userId: number

            }

export class UsersService {

	/**
	 * Set Active Brand Me
	 * Set httpOnly cookie for active product brand (wysehub | aiclaims).
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static setActiveBrandMe(data: TDataSetActiveBrandMe): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/users/me/active-brand',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Users
	 * Retrieve users.
	 * @returns UsersPublic Successful Response
	 * @throws ApiError
	 */
	public static readUsers(data: TDataReadUsers = {}): CancelablePromise<UsersPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create User
	 * Create new user.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static createUser(data: TDataCreateUser): CancelablePromise<UserPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/users/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read User Me
	 * Get current user information after successful login and OTP verification.
 * Requires a valid access token in the HttpOnly cookie.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserMe(): CancelablePromise<UserPublic> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/me',
		});
	}

	/**
	 * Delete User Me
	 * Delete own user.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteUserMe(): CancelablePromise<Message> {
				return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/users/me',
		});
	}

	/**
	 * Update User Me
	 * Update own user.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static updateUserMe(data: TDataUpdateUserMe): CancelablePromise<UserPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/users/me',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Password Me
	 * Update own password.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static updatePasswordMe(data: TDataUpdatePasswordMe): CancelablePromise<Message> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/users/me/password',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Register User
	 * Create new user without the need to be logged in.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static registerUser(data: TDataRegisterUser): CancelablePromise<UserPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/users/signup',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Service Accounts
	 * @returns UsersPublic Successful Response
	 * @throws ApiError
	 */
	public static readServiceAccounts(data: TDataReadServiceAccounts = {}): CancelablePromise<UsersPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/service-accounts',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Service Account
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static createServiceAccount(data: TDataCreateServiceAccount): CancelablePromise<UserPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/users/service-accounts',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read User By Id
	 * Get a specific user by id.
 *
 * SECURITY (AUTHZ-VULN-01): Users can only read their own profile
 * unless they are a System Administrator or have explicit permission.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserById(data: TDataReadUserById): CancelablePromise<UserPublic> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/{user_id}',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update User
	 * Update a user.
	 * @returns UserPublic Successful Response
	 * @throws ApiError
	 */
	public static updateUser(data: TDataUpdateUser): CancelablePromise<UserPublic> {
		const {
requestBody,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/users/{user_id}',
			path: {
				user_id: userId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete User
	 * Delete a user.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteUser(data: TDataDeleteUser): CancelablePromise<Message> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/users/{user_id}',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Login History
	 * Retrieve login history for a specific user.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getLoginHistory(data: TDataGetLoginHistory): CancelablePromise<unknown> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/{user_id}/login-history',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Api Key For User
	 * Generate and save an API key for a specific user.
 *
 * SECURITY (AUTHZ-VULN-03): Users can only generate API keys for themselves
 * unless they are a System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateApiKeyForUser(data: TDataGenerateApiKeyForUser): CancelablePromise<unknown> {
		const {
requestBody,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/users/{user_id}/generate-api-key',
			path: {
				user_id: userId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Api Keys For User
	 * @returns ApiKeysMetadataPublic Successful Response
	 * @throws ApiError
	 */
	public static listApiKeysForUser(data: TDataListApiKeysForUser): CancelablePromise<ApiKeysMetadataPublic> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/users/{user_id}/api-keys',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Api Key For User
	 * @returns ApiKeyMetadataPublic Successful Response
	 * @throws ApiError
	 */
	public static updateApiKeyForUser(data: TDataUpdateApiKeyForUser): CancelablePromise<ApiKeyMetadataPublic> {
		const {
apiKeyId,
requestBody,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/users/{user_id}/api-keys/{api_key_id}',
			path: {
				user_id: userId, api_key_id: apiKeyId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataTestEmail = {
                emailTo: string

            }

export class UtilsService {

	/**
	 * Test Email
	 * Test emails.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static testEmail(data: TDataTestEmail): CancelablePromise<Message> {
		const {
emailTo,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/utils/test-email/',
			query: {
				email_to: emailTo
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Csp Report
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static cspReport(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/utils/csp-report/',
		});
	}

	/**
	 * Internal Health Check
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static internalHealthCheck(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/utils/health',
		});
	}

	/**
	 * Connection Status
	 * Get database connection pool status and active connections
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static connectionStatus(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/utils/connection-status',
		});
	}

	/**
	 * Metrics
	 * Expose Prometheus metrics endpoint.
 * This endpoint is used by Prometheus to scrape metrics from the application.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static metrics(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/utils/metrics',
		});
	}

	/**
	 * Sms Handler
	 * Handle incoming SMS messages from Twilio.
 *
 * This endpoint:
 * 1. Receives SMS messages sent via Twilio
 * 2. Extracts the sender's phone number
 * 3. Looks up the number in the client phone numbers in the claim table
 * 4. Forwards the message to info@wysehub.co.uk
 * 5. Responds with a thank you message
 *
 * Returns:
 * Response: A TwiML response with a thank you message
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static smsHandler(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/utils/sms/',
		});
	}

}

export type TDataUtilsGetGrafanaMcpContext = {
                direction?: string
end?: string | null
limit?: number
logQuery?: string | null
queryTemplate?: string | null
start?: string | null

            }

export class MonitoringService {

	/**
	 * Get Grafana Mcp Context
	 * Fetch monitoring data from Grafana for Model Context Protocol (MCP).
 * This function provides monitoring data in a format that conforms to the Model Context Protocol.
 *
 * Returns:
 * Dict[str, Any]: A dictionary containing monitoring data in MCP format
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static utilsGetGrafanaMcpContext(data: TDataUtilsGetGrafanaMcpContext = {}): CancelablePromise<Record<string, unknown>> {
		const {
direction = 'backward',
end,
limit = 100,
logQuery,
queryTemplate,
start,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/utils/grafanamcp',
			query: {
				log_query: logQuery, query_template: queryTemplate, start, end, limit, direction
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListAgentRuns = {
                agentName?: string | null
claimId?: number | null
fromDate?: string | null
limit?: number
referralId?: number | null
runType?: string | null
skip?: number
status?: string | null
taskId?: string | null
toDate?: string | null
userId?: number | null

            }
export type TDataGetAgentRunSummary = {
                fromDate?: string | null
toDate?: string | null

            }
export type TDataGetAgentRun = {
                runId: string

            }

export class AgentRunsService {

	/**
	 * List Agent Runs
	 * @returns AgentRunsPublic Successful Response
	 * @throws ApiError
	 */
	public static listAgentRuns(data: TDataListAgentRuns = {}): CancelablePromise<AgentRunsPublic> {
		const {
agentName,
claimId,
fromDate,
limit = 100,
referralId,
runType,
skip = 0,
status,
taskId,
toDate,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/agent-runs/',
			query: {
				skip, limit, agentName, runType, status, referralId, claimId, userId, taskId, fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Agent Run Summary
	 * @returns AgentRunSummary Successful Response
	 * @throws ApiError
	 */
	public static getAgentRunSummary(data: TDataGetAgentRunSummary = {}): CancelablePromise<AgentRunSummary> {
		const {
fromDate,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/agent-runs/summary',
			query: {
				fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Agent Run
	 * @returns AgentRunPublic Successful Response
	 * @throws ApiError
	 */
	public static getAgentRun(data: TDataGetAgentRun): CancelablePromise<AgentRunPublic> {
		const {
runId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/agent-runs/{run_id}',
			path: {
				run_id: runId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataGetRunInspection = {
                /**
 * Filter items on or after this datetime
 */
fromDate?: string | null
referralId: number
/**
 * Filter items on or before this datetime
 */
toDate?: string | null

            }

export class RunInspectorService {

	/**
	 * Get Run Inspection
	 * Get aggregated run inspection data for a referral:
 * - All agent_runs for the referral (timeline)
 * - All claim summaries for the referral
 * - Workflow definition if workflow_id exists on claim summary or agent run
 * - Optional from_date/to_date filter on started_at and created_datetime
	 * @returns RunInspectorResponse Successful Response
	 * @throws ApiError
	 */
	public static getRunInspection(data: TDataGetRunInspection): CancelablePromise<RunInspectorResponse> {
		const {
fromDate,
referralId,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/run-inspector/referral/{referral_id}',
			path: {
				referral_id: referralId
			},
			query: {
				fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListWorkflows = {
                /**
 * Filter by workflow status, e.g. 'published' or 'sandbox'
 */
statusFilter?: string | null

            }
export type TDataCreateWorkflow = {
                requestBody: CreateRequest

            }
export type TDataGetWorkflow = {
                workflowId: number

            }
export type TDataUpdateWorkflow = {
                requestBody: EditRequest
workflowId: number

            }
export type TDataCloneWorkflow = {
                requestBody: CloneRequest
workflowId: number

            }
export type TDataTestWorkflowOnClaim = {
                requestBody: TestRequest
workflowId: number

            }
export type TDataCompareWorkflows = {
                requestBody: CompareRequest

            }

export class WorkflowDefinitionsService {

	/**
	 * List Registered Workflow Engines
	 * List workflow engines available for engine steps (remote registry).
	 * @returns RegisteredEngineListResponse Successful Response
	 * @throws ApiError
	 */
	public static listRegisteredWorkflowEngines(): CancelablePromise<RegisteredEngineListResponse> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-definitions/engines',
		});
	}

	/**
	 * List Workflows
	 * List all workflow definitions, optionally filtered by status.
	 * @returns WorkflowListResponse Successful Response
	 * @throws ApiError
	 */
	public static listWorkflows(data: TDataListWorkflows = {}): CancelablePromise<WorkflowListResponse> {
		const {
statusFilter,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-definitions/',
			query: {
				statusFilter
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Workflow
	 * Create a new workflow definition row.
	 * @returns app__api__routes__workflow_definitions__WorkflowDefinitionPublic Successful Response
	 * @throws ApiError
	 */
	public static createWorkflow(data: TDataCreateWorkflow): CancelablePromise<app__api__routes__workflow_definitions__WorkflowDefinitionPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/workflow-definitions/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow
	 * Get a single workflow by ID.
	 * @returns app__api__routes__workflow_definitions__WorkflowDefinitionPublic Successful Response
	 * @throws ApiError
	 */
	public static getWorkflow(data: TDataGetWorkflow): CancelablePromise<app__api__routes__workflow_definitions__WorkflowDefinitionPublic> {
		const {
workflowId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-definitions/{workflow_id}',
			path: {
				workflow_id: workflowId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Workflow
	 * Update a workflow's definition in place.
	 * @returns app__api__routes__workflow_definitions__WorkflowDefinitionPublic Successful Response
	 * @throws ApiError
	 */
	public static updateWorkflow(data: TDataUpdateWorkflow): CancelablePromise<app__api__routes__workflow_definitions__WorkflowDefinitionPublic> {
		const {
requestBody,
workflowId,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/workflow-definitions/{workflow_id}',
			path: {
				workflow_id: workflowId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Clone Workflow
	 * Clone a workflow to a partner override or the default scope.
	 * @returns app__api__routes__workflow_definitions__WorkflowDefinitionPublic Successful Response
	 * @throws ApiError
	 */
	public static cloneWorkflow(data: TDataCloneWorkflow): CancelablePromise<app__api__routes__workflow_definitions__WorkflowDefinitionPublic> {
		const {
requestBody,
workflowId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/workflow-definitions/{workflow_id}/clone',
			path: {
				workflow_id: workflowId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Test Workflow On Claim
	 * Run this workflow on a referral. Dispatches the selected workflow audit scope.
 * Returns task_id for polling; user can use Run Inspector to see results.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static testWorkflowOnClaim(data: TDataTestWorkflowOnClaim): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
workflowId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/workflow-definitions/{workflow_id}/test',
			path: {
				workflow_id: workflowId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Compare Workflows
	 * Run two workflows on the same referral for side-by-side comparison.
 * Returns task_id_a and task_id_b for polling.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static compareWorkflows(data: TDataCompareWorkflows): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/workflow-definitions/compare',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListWorkflowBillingEvents = {
                billingPeriod?: string | null
evaluationMode?: boolean | null
limit?: number
partnerId?: number | null
skip?: number
status?: string | null
workflowKey?: string | null

            }
export type TDataGetEventsForBillingPeriod = {
                billingPeriod: string
partnerId?: number | null
status?: string | null

            }
export type TDataGetWorkflowBillingEventById = {
                eventId: number

            }
export type TDataPatchWorkflowBillingEvent = {
                eventId: number
requestBody: WorkflowBillingEventUpdate

            }
export type TDataMarkBillingEventsBilled = {
                invoiceId: number
requestBody: Array<string>

            }

export class WorkflowBillingService {

	/**
	 * List Workflow Billing Events
	 * @returns WorkflowBillingEventsPublic Successful Response
	 * @throws ApiError
	 */
	public static listWorkflowBillingEvents(data: TDataListWorkflowBillingEvents = {}): CancelablePromise<WorkflowBillingEventsPublic> {
		const {
billingPeriod,
evaluationMode,
limit = 100,
partnerId,
skip = 0,
status,
workflowKey,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-billing/',
			query: {
				skip, limit, partnerId, workflowKey, billingPeriod, status, evaluationMode
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Events For Billing Period
	 * Return all pending billing events for a given month, suitable for invoice generation.
	 * @returns WorkflowBillingEventsPublic Successful Response
	 * @throws ApiError
	 */
	public static getEventsForBillingPeriod(data: TDataGetEventsForBillingPeriod): CancelablePromise<WorkflowBillingEventsPublic> {
		const {
billingPeriod,
partnerId,
status,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-billing/for-period',
			query: {
				billingPeriod, partnerId, status
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow Billing Event By Id
	 * @returns WorkflowBillingEventPublic Successful Response
	 * @throws ApiError
	 */
	public static getWorkflowBillingEventById(data: TDataGetWorkflowBillingEventById): CancelablePromise<WorkflowBillingEventPublic> {
		const {
eventId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/workflow-billing/{event_id}',
			path: {
				event_id: eventId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Patch Workflow Billing Event
	 * Update status or invoice_id on a billing event (e.g. mark as excluded/capped).
	 * @returns WorkflowBillingEventPublic Successful Response
	 * @throws ApiError
	 */
	public static patchWorkflowBillingEvent(data: TDataPatchWorkflowBillingEvent): CancelablePromise<WorkflowBillingEventPublic> {
		const {
eventId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/workflow-billing/{event_id}',
			path: {
				event_id: eventId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Mark Billing Events Billed
	 * Mark a set of billing events (by task_id) as billed and associate an invoice.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static markBillingEventsBilled(data: TDataMarkBillingEventsBilled): CancelablePromise<Record<string, unknown>> {
		const {
invoiceId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/workflow-billing/mark-billed',
			query: {
				invoiceId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadPartners = {
                limit?: number
skip?: number

            }
export type TDataCreatePartner = {
                requestBody: PartnerCreate

            }
export type TDataReadPartner = {
                id: number

            }
export type TDataUpdatePartner = {
                id: number
requestBody: PartnerUpdate

            }
export type TDataDeletePartner = {
                id: number

            }

export class PartnersService {

	/**
	 * Read Partners
	 * Retrieve partners.
	 * @returns PartnersPublic Successful Response
	 * @throws ApiError
	 */
	public static readPartners(data: TDataReadPartners = {}): CancelablePromise<PartnersPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partners/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Partner
	 * Create new partner.
	 * @returns PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static createPartner(data: TDataCreatePartner): CancelablePromise<PartnerPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/partners/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Partner
	 * Get partner by ID.
 *
 * SECURITY (AUTHZ-VULN-04): Users can only read partners they are affiliated with
 * unless they are a System Administrator.
	 * @returns PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static readPartner(data: TDataReadPartner): CancelablePromise<PartnerPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partners/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Partner
	 * Update a partner.
 *
 * SECURITY (AUTHZ-VULN-05): Users can only update partners they are affiliated with
 * unless they are a System Administrator.
	 * @returns PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static updatePartner(data: TDataUpdatePartner): CancelablePromise<PartnerPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/partners/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Partner
	 * Delete an partner.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deletePartner(data: TDataDeletePartner): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/partners/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}



export class PermissionsService {

	/**
	 * Read My Pages
	 * Return frontend page keys that the authenticated user can access.
	 * @returns MyPagesResponse Successful Response
	 * @throws ApiError
	 */
	public static readMyPages(): CancelablePromise<MyPagesResponse> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/permissions/my-pages',
		});
	}

	/**
	 * Read Permission Catalog
	 * Return dynamic endpoint and page permission catalog for matrix UIs.
	 * @returns PermissionCatalogResponse Successful Response
	 * @throws ApiError
	 */
	public static readPermissionCatalog(): CancelablePromise<PermissionCatalogResponse> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/permissions/catalog',
		});
	}

}

export type TDataReadInsurers = {
                limit?: number
skip?: number

            }
export type TDataCreateInsurer = {
                requestBody: InsurerCreate

            }
export type TDataReadInsurer = {
                id: number

            }
export type TDataUpdateInsurer = {
                id: number
requestBody: InsurerUpdate

            }
export type TDataDeleteInsurer = {
                id: number

            }

export class InsurersService {

	/**
	 * Read Insurers
	 * Retrieve insurers.
	 * @returns InsurersPublic Successful Response
	 * @throws ApiError
	 */
	public static readInsurers(data: TDataReadInsurers = {}): CancelablePromise<InsurersPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/insurers/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Insurer
	 * Create new insurer.
	 * @returns InsurerPublic Successful Response
	 * @throws ApiError
	 */
	public static createInsurer(data: TDataCreateInsurer): CancelablePromise<InsurerPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/insurers/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Insurer
	 * Get insurer by ID.
	 * @returns InsurerPublic Successful Response
	 * @throws ApiError
	 */
	public static readInsurer(data: TDataReadInsurer): CancelablePromise<InsurerPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/insurers/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Insurer
	 * Update an insurer.
	 * @returns InsurerPublic Successful Response
	 * @throws ApiError
	 */
	public static updateInsurer(data: TDataUpdateInsurer): CancelablePromise<InsurerPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/insurers/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Insurer
	 * Delete an insurer.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteInsurer(data: TDataDeleteInsurer): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/insurers/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadPartnerRules = {
                limit?: number
skip?: number

            }
export type TDataCreatePartnerRule = {
                requestBody: Partner_RuleCreate

            }
export type TDataReadPartnerRule = {
                id: number

            }
export type TDataUpdatePartnerRule = {
                id: number
requestBody: Partner_RuleUpdate

            }
export type TDataDeletePartnerRule = {
                id: number

            }

export class PartnerRulesService {

	/**
	 * Read Partner Rules
	 * Retrieve partner_rule_rates.
	 * @returns Partner_RulesPublic Successful Response
	 * @throws ApiError
	 */
	public static readPartnerRules(data: TDataReadPartnerRules = {}): CancelablePromise<Partner_RulesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partner_rules/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Partner Rule
	 * Create new partner_rule or update existing one.
	 * @returns Partner_RulePublic Successful Response
	 * @throws ApiError
	 */
	public static createPartnerRule(data: TDataCreatePartnerRule): CancelablePromise<Partner_RulePublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/partner_rules/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Partner Rule
	 * Get partner_rule_rate by ID.
	 * @returns Partner_RulePublic Successful Response
	 * @throws ApiError
	 */
	public static readPartnerRule(data: TDataReadPartnerRule): CancelablePromise<Partner_RulePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partner_rules/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Partner Rule
	 * Update an partner_rule.
	 * @returns Partner_RulePublic Successful Response
	 * @throws ApiError
	 */
	public static updatePartnerRule(data: TDataUpdatePartnerRule): CancelablePromise<Partner_RulePublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/partner_rules/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Partner Rule
	 * Delete an partner_rule.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deletePartnerRule(data: TDataDeletePartnerRule): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/partner_rules/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadCircsGrades = {
                limit?: number
skip?: number

            }
export type TDataCreateCircsGrade = {
                requestBody: Circs_GradeCreate

            }
export type TDataReadCircsGrade = {
                id: number

            }
export type TDataUpdateCircsGrade = {
                id: number
requestBody: Circs_GradeUpdate

            }
export type TDataDeleteCircsGrade = {
                id: number

            }

export class CircsGradesService {

	/**
	 * Read Circs Grades
	 * Retrieve circs_grades.
	 * @returns Circs_GradesPublic Successful Response
	 * @throws ApiError
	 */
	public static readCircsGrades(data: TDataReadCircsGrades = {}): CancelablePromise<Circs_GradesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/circs_grades/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Circs Grade
	 * Create new circs_grade.
	 * @returns Circs_GradePublic Successful Response
	 * @throws ApiError
	 */
	public static createCircsGrade(data: TDataCreateCircsGrade): CancelablePromise<Circs_GradePublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/circs_grades/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Circs Grade
	 * Get circs_grade by ID.
	 * @returns Circs_GradePublic Successful Response
	 * @throws ApiError
	 */
	public static readCircsGrade(data: TDataReadCircsGrade): CancelablePromise<Circs_GradePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/circs_grades/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Circs Grade
	 * Update an circs_grade.
	 * @returns Circs_GradePublic Successful Response
	 * @throws ApiError
	 */
	public static updateCircsGrade(data: TDataUpdateCircsGrade): CancelablePromise<Circs_GradePublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/circs_grades/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Circs Grade
	 * Delete an circs_grade.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteCircsGrade(data: TDataDeleteCircsGrade): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/circs_grades/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadClaims = {
                limit?: number
skip?: number

            }
export type TDataCreateClaim = {
                requestBody: ClaimCreate

            }
export type TDataReadClaim = {
                id: number

            }
export type TDataUpdateClaim = {
                id: number
requestBody: ClaimUpdate

            }
export type TDataDeleteClaim = {
                id: number

            }

export class ClaimsService {

	/**
	 * Read Claims
	 * Retrieve claims.
	 * @returns ClaimsPublic Successful Response
	 * @throws ApiError
	 */
	public static readClaims(data: TDataReadClaims = {}): CancelablePromise<ClaimsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/claims/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Claim
	 * Create new claim.
	 * @returns ClaimPublic Successful Response
	 * @throws ApiError
	 */
	public static createClaim(data: TDataCreateClaim): CancelablePromise<ClaimPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/claims/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Claim
	 * Get claim by ID.
	 * @returns ClaimPublic Successful Response
	 * @throws ApiError
	 */
	public static readClaim(data: TDataReadClaim): CancelablePromise<ClaimPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/claims/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Claim
	 * Update an claim.
	 * @returns ClaimPublic Successful Response
	 * @throws ApiError
	 */
	public static updateClaim(data: TDataUpdateClaim): CancelablePromise<ClaimPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/claims/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Claim
	 * Delete an claim.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteClaim(data: TDataDeleteClaim): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/claims/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadComplaints = {
                limit?: number
skip?: number

            }
export type TDataCreateNewComplaint = {
                requestBody: ComplaintCreate

            }
export type TDataReadComplaint = {
                complaintId: number

            }
export type TDataUpdateExistingComplaint = {
                complaintId: number
requestBody: ComplaintUpdate

            }
export type TDataDeleteExistingComplaint = {
                complaintId: number

            }
export type TDataReadComplaintsByReferral = {
                limit?: number
referralId: number
skip?: number

            }

export class ComplaintsService {

	/**
	 * Read Complaints
	 * Retrieve complaints.
	 * @returns ComplaintsPublic Successful Response
	 * @throws ApiError
	 */
	public static readComplaints(data: TDataReadComplaints = {}): CancelablePromise<ComplaintsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/complaints/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create New Complaint
	 * Create new complaint.
	 * @returns ComplaintPublic Successful Response
	 * @throws ApiError
	 */
	public static createNewComplaint(data: TDataCreateNewComplaint): CancelablePromise<ComplaintPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/complaints/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Complaint
	 * Get complaint by ID.
 *
 * SECURITY (AUTHZ-VULN-09): Users can only read complaints for referrals
 * they are involved with, unless they are a System Administrator.
	 * @returns ComplaintPublic Successful Response
	 * @throws ApiError
	 */
	public static readComplaint(data: TDataReadComplaint): CancelablePromise<ComplaintPublic> {
		const {
complaintId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/complaints/{complaint_id}',
			path: {
				complaint_id: complaintId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Existing Complaint
	 * Update a complaint.
 *
 * SECURITY (AUTHZ-VULN-10): Users can only update complaints for referrals
 * they are involved with, unless they are a System Administrator.
	 * @returns ComplaintPublic Successful Response
	 * @throws ApiError
	 */
	public static updateExistingComplaint(data: TDataUpdateExistingComplaint): CancelablePromise<ComplaintPublic> {
		const {
complaintId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/complaints/{complaint_id}',
			path: {
				complaint_id: complaintId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Existing Complaint
	 * Delete a complaint.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteExistingComplaint(data: TDataDeleteExistingComplaint): CancelablePromise<Message> {
		const {
complaintId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/complaints/{complaint_id}',
			path: {
				complaint_id: complaintId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Complaints By Referral
	 * Get all complaints for a specific referral.
	 * @returns ComplaintsPublic Successful Response
	 * @throws ApiError
	 */
	public static readComplaintsByReferral(data: TDataReadComplaintsByReferral): CancelablePromise<ComplaintsPublic> {
		const {
limit = 100,
referralId,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/complaints/referral/{referral_id}',
			path: {
				referral_id: referralId
			},
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadReferralAllocationsBytype = {
                limit?: number
partnertype?: string
skip?: number

            }
export type TDataCreateReferralAllocation = {
                requestBody: Referral_AllocationCreate

            }
export type TDataReadReferralAllocation = {
                id: number

            }
export type TDataUpdateReferralAllocation = {
                id: number
requestBody: Referral_AllocationUpdate

            }
export type TDataDeleteReferralAllocation = {
                id: number

            }
export type TDataPartnerUpdateAllocation = {
                requestBody: Referral_AllocationUpdate

            }
export type TDataReallocateReferral = {
                requestBody: Referral_AllocationReallocate

            }
export type TDataGetReferralAllocationAuditHistory = {
                id: number
limit?: number
skip?: number

            }

export class ReferralAllocationsService {

	/**
	 * Read Referral Allocations Bytype
	 * Retrieve referral_allocations.
	 * @returns Referral_AllocationsPublic Successful Response
	 * @throws ApiError
	 */
	public static readReferralAllocationsBytype(data: TDataReadReferralAllocationsBytype = {}): CancelablePromise<Referral_AllocationsPublic> {
		const {
limit = 100,
partnertype = 'unspecified',
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_allocations/',
			query: {
				partnertype, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Referral Allocation
	 * Create new referral_allocation.
	 * @returns Referral_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static createReferralAllocation(data: TDataCreateReferralAllocation): CancelablePromise<Referral_AllocationPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_allocations/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Referral Allocation
	 * Get referral_allocation by ID.
 *
 * SECURITY FIX (AUTHZ-VULN-06): Enforces referral involvement check.
 * Non-superusers can only access allocations for referrals they are involved with.
	 * @returns Referral_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static readReferralAllocation(data: TDataReadReferralAllocation): CancelablePromise<Referral_AllocationPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_allocations/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Referral Allocation
	 * Update an referral_allocation.
	 * @returns Referral_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static updateReferralAllocation(data: TDataUpdateReferralAllocation): CancelablePromise<Referral_AllocationPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/referral_allocations/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Referral Allocation
	 * Delete an referral_allocation.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteReferralAllocation(data: TDataDeleteReferralAllocation): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/referral_allocations/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Partner Update Allocation
	 * Update an referral_allocation and notify the source partner of any changes.
	 * @returns Referral_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static partnerUpdateAllocation(data: TDataPartnerUpdateAllocation): CancelablePromise<Referral_AllocationPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_allocations/update',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Reallocate Referral
	 * Allocate or reallocate a referral to a supplier partner.
 * If existing allocations exist, they will be cancelled and a new one created (reallocation).
 * If no existing allocations exist, a new allocation will be created (initial allocation).
	 * @returns Referral_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static reallocateReferral(data: TDataReallocateReferral): CancelablePromise<Referral_AllocationPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referral_allocations/reallocate',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Referral Allocation Audit History
	 * Get audit history for a referral allocation.
 * Returns all changes tracked for this allocation with timestamps and user information.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getReferralAllocationAuditHistory(data: TDataGetReferralAllocationAuditHistory): CancelablePromise<unknown> {
		const {
id,
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral_allocations/{id}/audit-history',
			path: {
				id
			},
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReferralsGenerateSummary = {
                requestBody: Record<string, unknown>

            }
export type TDataReferralsGetSummaryStatus = {
                taskId: string

            }
export type TDataReferralsGetLatestSummary = {
                referralId: number

            }
export type TDataReferralsGetSummaryHistory = {
                limit?: number
referralId: number

            }
export type TDataReferralsGetSummaryDetail = {
                summaryId: number

            }
export type TDataReadReferrals = {
                limit?: number
partnertype?: string
skip?: number

            }
export type TDataCreateReferral = {
                requestBody: ReferralCreate

            }
export type TDataReferralTableData = {
                /**
 * Page number (1-based)
 */
page?: number
/**
 * Items per page
 */
pageSize?: number
/**
 * Partner type filter
 */
partnertype?: string
/**
 * Search across referral ID, source ref, client names, vehicle registration, policy numbers, and supplier ref
 */
searchTerm?: string
/**
 * Sort direction
 */
sortDirection?: string
/**
 * Field to sort by
 */
sortField?: string

            }
export type TDataReferralChartData = {
                /**
 * Type of chart data to retrieve
 */
chartType: string
page?: number
pageSize?: number
partnertype?: string
searchTerm?: string

            }
export type TDataCountReferralsByStatus = {
                /**
 * List of allocation statuses to filter by
 */
statuses: Array<string>

            }
export type TDataCreateBulkSummaryOperation = {
                requestBody: Body_referrals_create_bulk_summary_operation

            }
export type TDataGetBulkOperationsHistory = {
                /**
 * Page size
 */
limit?: number
/**
 * Pagination offset
 */
skip?: number

            }
export type TDataGetBulkOperationStatus = {
                operationId: number

            }
export type TDataGetBulkOperationReferrals = {
                /**
 * Page size
 */
limit?: number
operationId: number
/**
 * Pagination offset
 */
skip?: number

            }
export type TDataStreamBulkOperationUpdates = {
                operationId: number

            }
export type TDataGetBulkOperationsMetrics = {
                /**
 * Number of days to analyze
 */
days?: number

            }
export type TDataReadReferral = {
                id: number

            }
export type TDataUpdateReferral = {
                id: number
requestBody: ReferralUpdate

            }
export type TDataDeleteReferral = {
                id: number

            }

export class ReferralsService {

	/**
	 * Generate Summary
	 * Generate an AI claim summary for a referral using the Celery AI task.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static referralsGenerateSummary(data: TDataReferralsGenerateSummary): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referrals/generate-summary',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary Status
	 * Poll the status/result of a claim summary generation task.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static referralsGetSummaryStatus(data: TDataReferralsGetSummaryStatus): CancelablePromise<Record<string, unknown>> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/summary-status/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Latest Summary
	 * Get the latest successful AI-generated summary for a referral.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static referralsGetLatestSummary(data: TDataReferralsGetLatestSummary): CancelablePromise<ClaimSummaryPublic | null> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/{referral_id}/summary/latest',
			path: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary History
	 * Get the history of AI-generated summaries for a referral.
	 * @returns ClaimSummaryPublic Successful Response
	 * @throws ApiError
	 */
	public static referralsGetSummaryHistory(data: TDataReferralsGetSummaryHistory): CancelablePromise<Array<ClaimSummaryPublic>> {
		const {
limit = 10,
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/{referral_id}/summary/history',
			path: {
				referral_id: referralId
			},
			query: {
				limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary Detail
	 * Get detailed information about a specific summary including prompts and context.
	 * @returns ClaimSummaryDetailPublic Successful Response
	 * @throws ApiError
	 */
	public static referralsGetSummaryDetail(data: TDataReferralsGetSummaryDetail): CancelablePromise<ClaimSummaryDetailPublic> {
		const {
summaryId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/summary/{summary_id}/detail',
			path: {
				summary_id: summaryId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Referrals
	 * Retrieve referrals.
	 * @returns ReferralsPublic Successful Response
	 * @throws ApiError
	 */
	public static readReferrals(data: TDataReadReferrals = {}): CancelablePromise<ReferralsPublic> {
		const {
limit = 20,
partnertype = 'unspecified',
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/',
			query: {
				partnertype, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Referral
	 * Create new referral.
	 * @returns ReferralPublic Successful Response
	 * @throws ApiError
	 */
	public static createReferral(data: TDataCreateReferral): CancelablePromise<ReferralPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referrals/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Referral Table Data
	 * Get paginated referral table data with search and sorting capabilities.
 * Optimized for table display with server-side pagination, search, and sorting.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static referralTableData(data: TDataReferralTableData = {}): CancelablePromise<unknown> {
		const {
page = 1,
pageSize = 20,
partnertype = 'unspecified',
searchTerm = '',
sortDirection = 'desc',
sortField = 'created_datetime',
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/table',
			query: {
				partnertype, page, page_size: pageSize, search_term: searchTerm, sort_field: sortField, sort_direction: sortDirection
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Referral Chart Data
	 * Get chart data for referrals with optimized, chart-specific queries.
 * Each chart type now uses only the data it actually needs, improving performance and accuracy.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static referralChartData(data: TDataReferralChartData): CancelablePromise<unknown> {
		const {
chartType,
page = 1,
pageSize = 100,
partnertype = 'unspecified',
searchTerm = '',
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/chartdata',
			query: {
				chart_type: chartType, partnertype, page, page_size: pageSize, search_term: searchTerm
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Count Referrals By Status
	 * Count referrals matching the specified allocation statuses.
 *
 * This endpoint is used by the bulk claim summaries feature to show administrators
 * how many referrals will be processed before initiating a bulk operation.
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * statuses: List of allocation statuses (e.g., ["pending/new", "On Hire", "Booked in", "Cancelled"])
 *
 * Returns:
 * Dictionary with count and statuses
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
 * HTTPException: 400 if no statuses provided
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static countReferralsByStatus(data: TDataCountReferralsByStatus): CancelablePromise<Record<string, unknown>> {
		const {
statuses,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/count-by-status/',
			query: {
				statuses
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Bulk Summary Operation
	 * Create a bulk operation to generate claim summaries for multiple referrals.
 *
 * This endpoint initiates a background task that will process all referrals matching
 * the specified allocation statuses and generate AI-powered claim summaries for each.
 *
 * Security measures:
 * - Rate limiting: 5 operations per hour per user
 * - Concurrent operations: Maximum 3 system-wide
 * - Operation timeout: 1 hour maximum
 * - Audit logging: All attempts logged
 * - Permission enforcement: System Administrator role required
 *
 * Args:
 * request: FastAPI request object
 * session: Database session
 * current_user: Current authenticated user
 * allocation_statuses: List of allocation statuses to filter referrals
 * model: AI model key (see BEDROCK_SUMMARY_MODEL_KEYS)
 * version: Summary length ('simple', 'standard', or 'enhanced')
 * priority: Task priority (0-9, where 9 is highest priority)
 *
 * Returns:
 * BulkOperationPublic: Created bulk operation with task details
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
 * HTTPException: 400 if validation fails
 * HTTPException: 429 if rate limit exceeded
 * HTTPException: 503 if concurrent operation limit reached
	 * @returns BulkOperationPublic Successful Response
	 * @throws ApiError
	 */
	public static createBulkSummaryOperation(data: TDataCreateBulkSummaryOperation): CancelablePromise<BulkOperationPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referrals/bulk-generate-summaries',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Cleanup Timed Out Bulk Operations
	 * Clean up bulk operations that have timed out.
 *
 * This endpoint manually triggers cleanup of operations that are stuck in
 * 'pending' or 'in_progress' status but have exceeded the 1-hour timeout.
 *
 * This is useful for:
 * - Freeing up concurrent operation slots
 * - Cleaning up after worker crashes
 * - Manual intervention when operations are stuck
 *
 * Security:
 * - System Administrator role required
 *
 * Returns:
 * dict: Summary of cleanup operation
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static cleanupTimedOutBulkOperations(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/referrals/bulk-operations/cleanup-timed-out',
		});
	}

	/**
	 * Get Bulk Operations History
	 * Get paginated list of bulk operations for the current user.
 *
 * This endpoint retrieves the history of bulk summary generation operations,
 * ordered by creation date (most recent first).
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * skip: Number of records to skip (default: 0)
 * limit: Maximum number of records to return (default: 20, max: 100)
 *
 * Returns:
 * BulkOperationsPublic: Paginated list with count
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getBulkOperationsHistory(data: TDataGetBulkOperationsHistory = {}): CancelablePromise<unknown> {
		const {
limit = 20,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Bulk Operation Status
	 * Get the status and details of a bulk operation.
 *
 * This endpoint retrieves the current status of a bulk summary generation operation,
 * including progress information, success/failure counts, and any errors that occurred.
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * operation_id: ID of the bulk operation to retrieve
 *
 * Returns:
 * BulkOperationPublic: Operation status with all details including errors array
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
 * HTTPException: 404 if operation not found
	 * @returns BulkOperationPublic Successful Response
	 * @throws ApiError
	 */
	public static getBulkOperationStatus(data: TDataGetBulkOperationStatus): CancelablePromise<BulkOperationPublic> {
		const {
operationId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations/{operation_id}',
			path: {
				operation_id: operationId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Bulk Operation Referrals
	 * List the referrals (claims) targeted by a bulk operation.
 *
 * Uses the stored configuration on the bulk operation to reconstruct the
 * referral selection (allocation_statuses) and returns referral + claim info.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getBulkOperationReferrals(data: TDataGetBulkOperationReferrals): CancelablePromise<Record<string, unknown>> {
		const {
limit = 100,
operationId,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations/{operation_id}/referrals',
			path: {
				operation_id: operationId
			},
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Stream Bulk Operation Updates
	 * Server-Sent Events stream for real-time bulk operation updates.
 *
 * Authentication: uses the same cookie/JWT auth as other internal endpoints.
 * Implementation: publishes updates on Redis pub/sub channel 'bulk_operation:{id}'.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamBulkOperationUpdates(data: TDataStreamBulkOperationUpdates): CancelablePromise<unknown> {
		const {
operationId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations/stream/{operation_id}',
			path: {
				operation_id: operationId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Stream Bulk Operations History
	 * Server-Sent Events stream for bulk operations history updates for the current user.
 *
 * Publishes lightweight notifications to trigger client-side refetch of the history list.
 * Channel: 'bulk_operations:user:{user_id}'.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamBulkOperationsHistory(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations/stream/history',
		});
	}

	/**
	 * Get Bulk Operations Metrics
	 * Get aggregated metrics for bulk operations over a specified time period.
 *
 * This endpoint provides monitoring data including:
 * - Total operations count
 * - Success/failure rates
 * - Average processing time
 * - Average referrals per operation
 * - Performance trends
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * days: Number of days to analyze (default: 7, max: 90)
 *
 * Returns:
 * Dictionary with aggregated metrics
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getBulkOperationsMetrics(data: TDataGetBulkOperationsMetrics = {}): CancelablePromise<Record<string, unknown>> {
		const {
days = 7,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/bulk-operations/metrics/summary',
			query: {
				days
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Referral
	 * Get referral by ID.
	 * @returns ReferralPublic Successful Response
	 * @throws ApiError
	 */
	public static readReferral(data: TDataReadReferral): CancelablePromise<ReferralPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referrals/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Referral
	 * Update an referral.
	 * @returns ReferralPublic Successful Response
	 * @throws ApiError
	 */
	public static updateReferral(data: TDataUpdateReferral): CancelablePromise<ReferralPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/referrals/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Referral
	 * Delete a referral.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteReferral(data: TDataDeleteReferral): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/referrals/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataGenerateSummary = {
                requestBody: Record<string, unknown>

            }
export type TDataGetSummaryStatus = {
                taskId: string

            }
export type TDataStreamSummaryStatus = {
                taskId: string

            }
export type TDataGetLatestSummary = {
                referralId: number

            }
export type TDataGetRecentSummaryRuns = {
                fromDate?: string | null
hireStatus?: string | null
limit?: number
skip?: number
status?: string | null
toDate?: string | null
version?: string | null
workflowId?: number | null

            }
export type TDataGetSummaryHistory = {
                limit?: number
referralId: number

            }
export type TDataGetSummaryDetail = {
                summaryId: number

            }
export type TDataGetBotScoresForReferral = {
                referralId: number

            }
export type TDataGetAuditReport = {
                requestBody: Record<string, unknown>

            }
export type TDataDownloadMattAuditPdf = {
                requestBody: Record<string, unknown>

            }
export type TDataGenerateWorkflowClaimsAudit = {
                requestBody: Record<string, unknown>

            }
export type TDataGenerateMattClaimsAudit = {
                requestBody: Record<string, unknown>

            }
export type TDataSubmitSummaryFeedback = {
                referralId: number
requestBody: SummaryFeedbackBody

            }

export class SummariesService {

	/**
	 * List Available Workflows
	 * List published workflows available for claim summary generation.
 * Returns workflow_key, display_name, and description for each workflow.
 * Uses referrals permission (same as other claim summary endpoints).
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listAvailableWorkflows(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/workflows',
		});
	}

	/**
	 * Generate Summary
	 * Generate an AI claim summary for a referral using the Celery AI task (async).
 * Returns a task_id for polling.
 *
 * Security features:
 * - Rate limiting: 100 requests per hour per user
 * - Input sanitization: All context data is sanitized
 * - Audit logging: All requests are logged
 * - Role-based access control: Checks user permissions
 *
 * Request body:
 * - referral_id: int (required) - The referral ID to generate summary for
 * - version: str (optional) - Summary version: 'simple', 'standard', or 'enhanced' (default: 'standard')
 * - model: str (optional) - AI model key (default: 'sonnet46'; see BEDROCK_SUMMARY_MODEL_KEYS)
 * - priority: int (optional) - Task priority (0-9, default 5, higher = more urgent)
 *
 * Summary versions:
 * - simple: Brief overview (1-2 sentences, ~150 tokens)
 * - standard: Balanced summary (1 paragraph, ~250 tokens)
 * - enhanced: Detailed analysis (2-3 paragraphs, ~500 tokens)
 *
 * Model options:
 * - sonnet46: Claude Sonnet 4.6 on Bedrock (default)
 * - sonnet: Claude Sonnet 4.5 via AWS Bedrock
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateSummary(data: TDataGenerateSummary): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/generate',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary Status
	 * Poll the status/result of a claim summary generation task.
 *
 * Returns:
 * - status: Task state (pending, started, success, failure, retry)
 * - result: Task result (if success)
 * - error: Error message (if failure)
 * - metadata: Task metadata including generation time, model version, etc.
 * - summary_id: Database ID of the saved summary (if available)
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getSummaryStatus(data: TDataGetSummaryStatus): CancelablePromise<Record<string, unknown>> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/status/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Stream Summary Status
	 * Stream the status of a claim summary generation task using Server-Sent Events.
 *
 * Returns real-time updates as the task progresses:
 * - started: Task has begun processing
 * - processing: Task is still running with elapsed time
 * - success: Task completed with result
 * - failure: Task failed with error message
 *
 * Connection remains open until task completes or client disconnects.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static streamSummaryStatus(data: TDataStreamSummaryStatus): CancelablePromise<unknown> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/stream/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Latest Summary
	 * Get the latest successful AI-generated summary for a referral.
 *
 * Returns the most recent successful summary with metadata.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getLatestSummary(data: TDataGetLatestSummary): CancelablePromise<ClaimSummaryPublic | null> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/latest/referral/{referral_id}',
			path: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Recent Summary Runs
	 * List recent claim summary runs across referrals for AI Claims users.
	 * @returns ClaimSummaryRecentRunsPublic Successful Response
	 * @throws ApiError
	 */
	public static getRecentSummaryRuns(data: TDataGetRecentSummaryRuns = {}): CancelablePromise<ClaimSummaryRecentRunsPublic> {
		const {
fromDate,
hireStatus,
limit = 50,
skip = 0,
status,
toDate,
version,
workflowId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/recent',
			query: {
				skip, limit, status, version, fromDate, toDate, hireStatus, workflowId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary History
	 * Get the history of AI-generated summaries for a referral.
 *
 * Returns up to `limit` summaries ordered by creation date (newest first).
 * Useful for tracking how summaries change over time as data changes.
	 * @returns ClaimSummaryPublic Successful Response
	 * @throws ApiError
	 */
	public static getSummaryHistory(data: TDataGetSummaryHistory): CancelablePromise<Array<ClaimSummaryPublic>> {
		const {
limit = 10,
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/history/referral/{referral_id}',
			path: {
				referral_id: referralId
			},
			query: {
				limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Summary Detail
	 * Get detailed information about a specific summary including prompts and context.
 *
 * This endpoint is useful for debugging and understanding how the AI generated
 * a particular summary. Only accessible to authorized users for audit purposes.
	 * @returns ClaimSummaryDetailPublic Successful Response
	 * @throws ApiError
	 */
	public static getSummaryDetail(data: TDataGetSummaryDetail): CancelablePromise<ClaimSummaryDetailPublic> {
		const {
summaryId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/detail/{summary_id}',
			path: {
				summary_id: summaryId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Bot Scores For Referral
	 * Get the latest score and summary for each Matt bot (Priya, Layla, Robyn, Tony, Omar, Remi)
 * for a referral.
 *
 * Uses agent_runs to find the most recent successful run per bot across all workflow runs.
 * Bots that have not run show score=None and summary='Not run'.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getBotScoresForReferral(data: TDataGetBotScoresForReferral): CancelablePromise<Array<Record<string, unknown>>> {
		const {
referralId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/summaries/referral/{referral_id}/bot-scores',
			path: {
				referral_id: referralId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Audit Report
	 * Generate a Matt audit report as HTML or PDF.
 *
 * Accepts the parsed Matt audit structure (alex, sally, finalUrgency) from the frontend.
 * Use format="html" (default) for viewable HTML, format="pdf" for downloadable PDF.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getAuditReport(data: TDataGetAuditReport): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/audit-report',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Download Matt Audit Pdf
	 * Legacy endpoint: generate and download a Matt audit report as PDF.
 * Prefer POST /audit-report with format=pdf.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static downloadMattAuditPdf(data: TDataDownloadMattAuditPdf): CancelablePromise<unknown> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/audit-report-pdf',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Workflow Claims Audit
	 * Run a config-driven workflow audit for a single referral.
 *
 * Request body:
 * - referral_id: int (required)
 * - workflow_key: str (required for non-default flows; defaults to matt)
 * - priority: int (optional, 0-9, default 5)
 * - partner_id: int (optional) - workflow partner override for admin/testing
 *
 * Returns:
 * - task_id: Celery task ID for polling / SSE
 * - summary_id: pending ClaimSummary record ID
 * - version: persisted summary version label
 * - workflow_key: workflow that was dispatched
 * - priority: task priority used
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateWorkflowClaimsAudit(data: TDataGenerateWorkflowClaimsAudit): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/workflow/audit',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * @deprecated
	 * Generate Matt Claims Audit
	 * Deprecated: use POST /workflow/audit. Kept for backward compatibility.
 *
 * Accepts the same body as /workflow/audit (including workflow_key).
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateMattClaimsAudit(data: TDataGenerateMattClaimsAudit): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/matt/audit',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Submit Summary Feedback
	 * Submit in-app thumbs-up/down feedback for an AI claim summary.
 *
 * Creates a ``FeedbackRequest`` + ``FeedbackResponse`` pair for local reporting
 * and Grafana trace linkage via ``agent_runs.otel_trace_id``.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static submitSummaryFeedback(data: TDataSubmitSummaryFeedback): CancelablePromise<Record<string, unknown>> {
		const {
referralId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/summaries/referral/{referral_id}/feedback',
			path: {
				referral_id: referralId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}



export class GrafanaService {

	/**
	 * Grafana Alert Webhook
	 * Receive Grafana Cloud webhook notifications with shared-secret validation.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static grafanaAlertWebhook(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/grafana/webhook/',
		});
	}

}

export type TDataReadSourceRates = {
                limit?: number
skip?: number

            }
export type TDataCreateSourceRate = {
                requestBody: Source_RateCreate

            }
export type TDataReadSourceRate = {
                id: number

            }
export type TDataUpdateSourceRate = {
                id: number
requestBody: Source_RateUpdate

            }
export type TDataDeleteSourceRate = {
                id: number

            }
export type TDataExpireSourceRates = {
                expiryDate: string
sourcePartnerId: number
tier?: string | null
vehicleType: string

            }

export class SourceRatesService {

	/**
	 * Read Source Rates
	 * Retrieve source_rate_rates.
	 * @returns Source_RatesPublic Successful Response
	 * @throws ApiError
	 */
	public static readSourceRates(data: TDataReadSourceRates = {}): CancelablePromise<Source_RatesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/source_rates/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Source Rate
	 * Create new source_rate.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static createSourceRate(data: TDataCreateSourceRate): CancelablePromise<Message> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/source_rates/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Source Rate
	 * Get source_rate_rate by ID.
	 * @returns Source_RatePublic Successful Response
	 * @throws ApiError
	 */
	public static readSourceRate(data: TDataReadSourceRate): CancelablePromise<Source_RatePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/source_rates/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Source Rate
	 * Update an source_rate.
	 * @returns Source_RatePublic Successful Response
	 * @throws ApiError
	 */
	public static updateSourceRate(data: TDataUpdateSourceRate): CancelablePromise<Source_RatePublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/source_rates/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Source Rate
	 * Delete an source_rate.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteSourceRate(data: TDataDeleteSourceRate): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/source_rates/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Expire Source Rates
	 * Expire source rates for a given vehicle_type, partner_id, source_partner_id, and tier.
 *
 * If tier is provided, only rates for that specific tier will be expired.
 * Otherwise, all tiers will be affected.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static expireSourceRates(data: TDataExpireSourceRates): CancelablePromise<Message> {
		const {
expiryDate,
sourcePartnerId,
tier,
vehicleType,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/source_rates/expire',
			query: {
				expiry_date: expiryDate, vehicle_type: vehicleType, source_partner_id: sourcePartnerId, tier
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadSupplierRates = {
                limit?: number
skip?: number

            }
export type TDataCreateSupplierRate = {
                requestBody: Supplier_RateCreate

            }
export type TDataReadSupplierRate = {
                id: number

            }
export type TDataUpdateSupplierRate = {
                id: number
requestBody: Supplier_RateUpdate

            }
export type TDataDeleteSupplierRate = {
                id: number

            }
export type TDataExpireSupplierRates = {
                expiryDate: string
sourcePartnerId: number
supplierPartnerId: number
vehicleType: string

            }

export class SupplierRatesService {

	/**
	 * Read Supplier Rates
	 * Retrieve supplier_rates.
	 * @returns Supplier_RatesPublic Successful Response
	 * @throws ApiError
	 */
	public static readSupplierRates(data: TDataReadSupplierRates = {}): CancelablePromise<Supplier_RatesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/supplier_rates/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Supplier Rate
	 * Create new supplier_rate.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static createSupplierRate(data: TDataCreateSupplierRate): CancelablePromise<Message> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/supplier_rates/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Supplier Rate
	 * Get supplier_rate_rate by ID.
	 * @returns Supplier_RatePublic Successful Response
	 * @throws ApiError
	 */
	public static readSupplierRate(data: TDataReadSupplierRate): CancelablePromise<Supplier_RatePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/supplier_rates/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Supplier Rate
	 * Update an supplier_rate.
	 * @returns Supplier_RatePublic Successful Response
	 * @throws ApiError
	 */
	public static updateSupplierRate(data: TDataUpdateSupplierRate): CancelablePromise<Supplier_RatePublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/supplier_rates/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Supplier Rate
	 * Delete an supplier_rate.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteSupplierRate(data: TDataDeleteSupplierRate): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/supplier_rates/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Expire Supplier Rates
	 * Expire supplier rates for a given vehicle_type, partner_id, and source_partner_id.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static expireSupplierRates(data: TDataExpireSupplierRates): CancelablePromise<Message> {
		const {
expiryDate,
sourcePartnerId,
supplierPartnerId,
vehicleType,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/supplier_rates/expire',
			query: {
				expiry_date: expiryDate, vehicle_type: vehicleType, supplier_partner_id: supplierPartnerId, source_partner_id: sourcePartnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadVehGroups = {
                limit?: number
skip?: number

            }
export type TDataCreateVehGroup = {
                requestBody: Veh_GroupCreate

            }
export type TDataReadUniqueTypes = {
                limit?: number
skip?: number

            }
export type TDataReadVehGroup = {
                id: number

            }
export type TDataUpdateVehGroup = {
                id: number
requestBody: Veh_GroupUpdate

            }
export type TDataDeleteVehGroup = {
                id: number

            }

export class VehGroupsService {

	/**
	 * Read Veh Groups
	 * Retrieve veh_groups.
	 * @returns Veh_GroupsPublic Successful Response
	 * @throws ApiError
	 */
	public static readVehGroups(data: TDataReadVehGroups = {}): CancelablePromise<Veh_GroupsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/veh_groups/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Veh Group
	 * Create new veh_group.
	 * @returns Veh_GroupPublic Successful Response
	 * @throws ApiError
	 */
	public static createVehGroup(data: TDataCreateVehGroup): CancelablePromise<Veh_GroupPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/veh_groups/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Unique Types
	 * Retrieve a unique list of values from the 'type' column in veh_group.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static readUniqueTypes(data: TDataReadUniqueTypes = {}): CancelablePromise<Array<string>> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/veh_groups/types',
			query: {
				_skip: skip, _limit: limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Veh Group
	 * Get veh_group by ID.
	 * @returns Veh_GroupPublic Successful Response
	 * @throws ApiError
	 */
	public static readVehGroup(data: TDataReadVehGroup): CancelablePromise<Veh_GroupPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/veh_groups/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Veh Group
	 * Update an veh_group.
	 * @returns Veh_GroupPublic Successful Response
	 * @throws ApiError
	 */
	public static updateVehGroup(data: TDataUpdateVehGroup): CancelablePromise<Veh_GroupPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/veh_groups/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Veh Group
	 * Delete an veh_group.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteVehGroup(data: TDataDeleteVehGroup): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/veh_groups/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadAuthorities = {
                limit?: number
skip?: number

            }
export type TDataCreateAuthority = {
                requestBody: AuthorityCreate

            }
export type TDataReadAuthority = {
                authorityId: number

            }
export type TDataUpdateAuthority = {
                authorityId: number
requestBody: AuthorityUpdate

            }
export type TDataDeleteAuthority = {
                authorityId: number

            }

export class AuthoritiesService {

	/**
	 * Read Authorities
	 * Retrieve authorities.
	 * @returns AuthoritiesPublic Successful Response
	 * @throws ApiError
	 */
	public static readAuthorities(data: TDataReadAuthorities = {}): CancelablePromise<AuthoritiesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/authorities/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Authority
	 * Create new authority.
	 * @returns AuthorityPublic Successful Response
	 * @throws ApiError
	 */
	public static createAuthority(data: TDataCreateAuthority): CancelablePromise<AuthorityPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/authorities/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Authority
	 * Get authority by ID.
	 * @returns AuthorityPublic Successful Response
	 * @throws ApiError
	 */
	public static readAuthority(data: TDataReadAuthority): CancelablePromise<AuthorityPublic> {
		const {
authorityId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/authorities/{authority_id}',
			path: {
				authority_id: authorityId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Authority
	 * Update an authority.
	 * @returns AuthorityPublic Successful Response
	 * @throws ApiError
	 */
	public static updateAuthority(data: TDataUpdateAuthority): CancelablePromise<AuthorityPublic> {
		const {
authorityId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/authorities/{authority_id}',
			path: {
				authority_id: authorityId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Authority
	 * Delete an authority.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteAuthority(data: TDataDeleteAuthority): CancelablePromise<Message> {
		const {
authorityId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/authorities/{authority_id}',
			path: {
				authority_id: authorityId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadUserPartners = {
                limit?: number
skip?: number

            }
export type TDataCreateUserPartner = {
                requestBody: User_PartnerCreate

            }
export type TDataReadUserPartner = {
                id: number

            }
export type TDataUpdateUserPartner = {
                id: number
requestBody: User_PartnerUpdate

            }
export type TDataDeleteUserPartner = {
                id: number

            }

export class UserPartnersService {

	/**
	 * Read User Partners
	 * Retrieve user_partners.
	 * @returns User_PartnersPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserPartners(data: TDataReadUserPartners = {}): CancelablePromise<User_PartnersPublic> {
		const {
limit = 500,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/user_partners/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create User Partner
	 * Create new user_partner.
	 * @returns User_PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static createUserPartner(data: TDataCreateUserPartner): CancelablePromise<User_PartnerPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/user_partners/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read User Partner
	 * Get user_partner by ID.
	 * @returns User_PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static readUserPartner(data: TDataReadUserPartner): CancelablePromise<User_PartnerPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/user_partners/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update User Partner
	 * Update an user_partner.
	 * @returns User_PartnerPublic Successful Response
	 * @throws ApiError
	 */
	public static updateUserPartner(data: TDataUpdateUserPartner): CancelablePromise<User_PartnerPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/user_partners/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete User Partner
	 * Delete an user_partner.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteUserPartner(data: TDataDeleteUserPartner): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/user_partners/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadRoleAllocations = {
                limit?: number
skip?: number

            }
export type TDataCreateRoleAllocation = {
                requestBody: Role_AllocationCreate

            }
export type TDataReadRoleAllocation = {
                id: number

            }
export type TDataUpdateRoleAllocation = {
                id: number
requestBody: Role_AllocationUpdate

            }
export type TDataDeleteRoleAllocation = {
                id: number

            }

export class RoleAllocationsService {

	/**
	 * Read Role Allocations
	 * Retrieve role_allocations.
	 * @returns Role_AllocationsPublic Successful Response
	 * @throws ApiError
	 */
	public static readRoleAllocations(data: TDataReadRoleAllocations = {}): CancelablePromise<Role_AllocationsPublic> {
		const {
limit = 500,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/role_allocations/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Role Allocation
	 * Create new role_allocation.
	 * @returns Role_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static createRoleAllocation(data: TDataCreateRoleAllocation): CancelablePromise<Role_AllocationPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/role_allocations/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Role Allocation
	 * Get role_allocation by ID.
	 * @returns Role_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static readRoleAllocation(data: TDataReadRoleAllocation): CancelablePromise<Role_AllocationPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/role_allocations/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Role Allocation
	 * Update an role_allocation.
	 * @returns Role_AllocationPublic Successful Response
	 * @throws ApiError
	 */
	public static updateRoleAllocation(data: TDataUpdateRoleAllocation): CancelablePromise<Role_AllocationPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/role_allocations/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Role Allocation
	 * Delete an role_allocation.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteRoleAllocation(data: TDataDeleteRoleAllocation): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/role_allocations/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadRoles = {
                limit?: number
skip?: number

            }
export type TDataCreateRole = {
                requestBody: RoleCreate

            }
export type TDataReadRole = {
                id: number

            }
export type TDataUpdateRole = {
                id: number
requestBody: RoleUpdate

            }
export type TDataDeleteRole = {
                id: number

            }

export class RolesService {

	/**
	 * Read Roles
	 * Retrieve roles.
	 * @returns RolesPublic Successful Response
	 * @throws ApiError
	 */
	public static readRoles(data: TDataReadRoles = {}): CancelablePromise<RolesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/roles/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Role
	 * Create new role.
	 * @returns RolePublic Successful Response
	 * @throws ApiError
	 */
	public static createRole(data: TDataCreateRole): CancelablePromise<RolePublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/roles/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Role
	 * Get role by ID.
	 * @returns RolePublic Successful Response
	 * @throws ApiError
	 */
	public static readRole(data: TDataReadRole): CancelablePromise<RolePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/roles/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Role
	 * Update an role.
	 * @returns RolePublic Successful Response
	 * @throws ApiError
	 */
	public static updateRole(data: TDataUpdateRole): CancelablePromise<RolePublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/roles/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Role
	 * Delete an role.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteRole(data: TDataDeleteRole): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/roles/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataReadRolePermissions = {
                limit?: number
skip?: number

            }
export type TDataCreateRolePermission = {
                requestBody: Role_PermissionCreate

            }
export type TDataReadRolePermission = {
                id: number

            }
export type TDataUpdateRolePermission = {
                id: number
requestBody: Role_PermissionUpdate

            }
export type TDataDeleteRolePermission = {
                id: number

            }

export class RolePermissionsService {

	/**
	 * Read Role Permissions
	 * Retrieve role_permissions.
	 * @returns Role_PermissionsPublic Successful Response
	 * @throws ApiError
	 */
	public static readRolePermissions(data: TDataReadRolePermissions = {}): CancelablePromise<Role_PermissionsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/role_permissions/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Role Permission
	 * Create new role_permission.
	 * @returns Role_PermissionPublic Successful Response
	 * @throws ApiError
	 */
	public static createRolePermission(data: TDataCreateRolePermission): CancelablePromise<Role_PermissionPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/role_permissions/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Role Permission
	 * Get role_permission by ID.
	 * @returns Role_PermissionPublic Successful Response
	 * @throws ApiError
	 */
	public static readRolePermission(data: TDataReadRolePermission): CancelablePromise<Role_PermissionPublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/role_permissions/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Role Permission
	 * Update an role_permission.
	 * @returns Role_PermissionPublic Successful Response
	 * @throws ApiError
	 */
	public static updateRolePermission(data: TDataUpdateRolePermission): CancelablePromise<Role_PermissionPublic> {
		const {
id,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/role_permissions/{id}',
			path: {
				id
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Role Permission
	 * Delete an role_permission.
	 * @returns Message Successful Response
	 * @throws ApiError
	 */
	public static deleteRolePermission(data: TDataDeleteRolePermission): CancelablePromise<Message> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/role_permissions/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataValidateOtp = {
                loginid: number
otp: number
userId: number

            }

export class OtpService {

	/**
	 * Validate Otp
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static validateOtp(data: TDataValidateOtp): CancelablePromise<unknown> {
		const {
loginid,
otp,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/otp/validate-otp/{user_id}',
			path: {
				user_id: userId
			},
			query: {
				otp, loginid
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}



export class ReferralReportsService {

	/**
	 * List Referral Csv Columns
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static listReferralCsvColumns(): CancelablePromise<Array<Record<string, string>>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/referral-reports/columns',
		});
	}

}



export class NewrefparserService {

	/**
	 * @deprecated
	 * Parse Email
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static parseEmail(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/newrefparser/parse-email/',
		});
	}

}

export type TDataIncomingCall = {
                formData: Body_calls_incoming_call

            }

export class CallsService {

	/**
	 * Incoming Call
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static incomingCall(data: TDataIncomingCall): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/calls/incoming-call/',
			formData: formData,
			mediaType: 'application/x-www-form-urlencoded',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataGenerateInvoiceRequestPdfBulk = {
                partnerId?: number | null

            }
export type TDataReadInvoices = {
                limit?: number
skip?: number

            }
export type TDataUpdateInvoiceStatus = {
                id: number
status: string

            }
export type TDataPayInvoice = {
                id: number

            }
export type TDataPayInvoiceWithLines = {
                id: number

            }
export type TDataCreditInvoice = {
                id: number

            }
export type TDataDeleteInvoice = {
                id: number

            }
export type TDataReadInvoice = {
                id: number

            }
export type TDataTriggerInvoiceGeneration = {
                billingDate: string

            }
export type TDataGetInvoiceTaskStatus = {
                taskId: string

            }
export type TDataGenerateInvoiceLinesDirect = {
                billingDate: string

            }
export type TDataGenerateInvoiceRequestLinesDirect = {
                billingDate: string

            }
export type TDataGetInvoiceLines = {
                /**
 * End date filter (YYYY-MM-DD)
 */
endDate?: string | null
/**
 * Maximum number of records to return
 */
limit?: number
/**
 * Partner ID filter (for repair billing)
 */
partnerId?: number | null
/**
 * Number of records to skip
 */
skip?: number
/**
 * Start date filter (YYYY-MM-DD)
 */
startDate?: string | null
/**
 * Status filter
 */
status?: string | null
/**
 * Invoice line type filter
 */
type?: string

            }
export type TDataUpdateInvoiceLineStatus = {
                id: number
status: string

            }
export type TDataUpdateInvoiceLineRate = {
                id: number
rate: number

            }
export type TDataUpdateInvoiceLineAmount = {
                /**
 * New amount
 */
amount?: number | null
/**
 * New billed amount
 */
billedAmount?: number | null
id: number

            }
export type TDataPayInvoiceLine = {
                id: number

            }
export type TDataGetInvoiceRequestLines = {
                limit?: number
skip?: number
status?: string | null

            }
export type TDataGetPendingRequestLinesBySupplier = {
                limit?: number
skip?: number

            }
export type TDataGenerateInvoiceRequestPdf = {
                lineId: number

            }
export type TDataGenerateApiUsageBillingLinesDirect = {
                billingDate: string

            }
export type TDataGeneratePartnerApiUsageBillingDirect = {
                billingDate: string
generateInvoice?: boolean
partnerId: number

            }
export type TDataGetApiUsageBillingSummaryAll = {
                endDate?: string | null
partnerId?: number | null
startDate?: string | null

            }
export type TDataGetApiUsageBillingSummary = {
                endDate?: string | null
partnerId: number
startDate?: string | null

            }
export type TDataGetXeroOnlineInvoiceUrl = {
                invoiceId: number

            }

export class InvoicesService {

	/**
	 * Generate Invoice Request Pdf Bulk
	 * Create invoice requests for all ready invoice request lines.
 * If partner_id is provided, only process that partner.
 * If partner_id is None, process all partners with ready lines.
 * Creates the Invoice record and updates all lines to 'requested' status.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateInvoiceRequestPdfBulk(data: TDataGenerateInvoiceRequestPdfBulk = {}): CancelablePromise<Record<string, unknown>> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-invoice-request-pdf-bulk',
			query: {
				partner_id: partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Invoices
	 * Retrieve invoices. Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readInvoices(data: TDataReadInvoices = {}): CancelablePromise<Record<string, unknown>> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Invoice Status
	 * Update invoice status. Only accessible by System Administrator.
 * Valid statuses: Pending, Paid, Part Paid, Cancelled, Credited
	 * @returns InvoicePublic Successful Response
	 * @throws ApiError
	 */
	public static updateInvoiceStatus(data: TDataUpdateInvoiceStatus): CancelablePromise<InvoicePublic> {
		const {
id,
status,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/{id}/status',
			path: {
				id
			},
			query: {
				status
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Pay Invoice
	 * Mark invoice as paid and also mark all related invoice lines as paid.
 * Only accessible by System Administrator.
	 * @returns InvoicePublic Successful Response
	 * @throws ApiError
	 */
	public static payInvoice(data: TDataPayInvoice): CancelablePromise<InvoicePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/{id}/pay',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Pay Invoice With Lines
	 * Mark invoice as paid and also mark all related invoice lines as paid.
 * Only accessible by System Administrator.
	 * @returns InvoicePublic Successful Response
	 * @throws ApiError
	 */
	public static payInvoiceWithLines(data: TDataPayInvoiceWithLines): CancelablePromise<InvoicePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/{id}/pay-with-lines',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Credit Invoice
	 * Mark invoice as credited. Only accessible by System Administrator.
	 * @returns InvoicePublic Successful Response
	 * @throws ApiError
	 */
	public static creditInvoice(data: TDataCreditInvoice): CancelablePromise<InvoicePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/{id}/credit',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Invoice
	 * Delete invoice. Only accessible by System Administrator.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteInvoice(data: TDataDeleteInvoice): CancelablePromise<Record<string, string>> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/invoices/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Invoice
	 * Get invoice by ID. Only accessible by System Administrator.
	 * @returns InvoicePublic Successful Response
	 * @throws ApiError
	 */
	public static readInvoice(data: TDataReadInvoice): CancelablePromise<InvoicePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/{id}',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Trigger Invoice Generation
	 * Trigger generation of invoices for a specific billing date.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static triggerInvoiceGeneration(data: TDataTriggerInvoiceGeneration): CancelablePromise<Record<string, unknown>> {
		const {
billingDate,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate',
			query: {
				billing_date: billingDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Invoice Task Status
	 * Poll the status/result of an invoice generation task.
 *
 * Restricted to system administrators; responses omit worker hostnames, internal IDs,
 * and raw Celery exception payloads.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getInvoiceTaskStatus(data: TDataGetInvoiceTaskStatus): CancelablePromise<Record<string, unknown>> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/status/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Invoice Lines Direct
	 * Generate invoice lines directly for a specific billing date.
 * This is the direct call version of generate_invoices_only from celery.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateInvoiceLinesDirect(data: TDataGenerateInvoiceLinesDirect): CancelablePromise<Record<string, unknown>> {
		const {
billingDate,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-invoice-lines',
			query: {
				billing_date: billingDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Invoice Request Lines Direct
	 * Generate invoice request lines directly for a specific billing date.
 * This creates invoice requests from eligible referrals.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateInvoiceRequestLinesDirect(data: TDataGenerateInvoiceRequestLinesDirect): CancelablePromise<Record<string, unknown>> {
		const {
billingDate,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-invoice-request-lines',
			query: {
				billing_date: billingDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Invoice Lines
	 * Retrieve invoice lines with optional filtering.
 * Supports both regular invoice lines (type='invoice') and repair billing lines (type='repair_billing').
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getInvoiceLines(data: TDataGetInvoiceLines = {}): CancelablePromise<Record<string, unknown>> {
		const {
endDate,
limit = 100,
partnerId,
skip = 0,
startDate,
status,
type = 'invoice',
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/invoice-lines',
			query: {
				type, status, partner_id: partnerId, start_date: startDate, end_date: endDate, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Invoice Line Status
	 * Update invoice line status.
 * Valid statuses for invoice lines: pending, ready, on_hold, rejected, invoiced, paid
 * Valid statuses for request lines: pending, ready, on_hold, rejected, requested
 * Valid statuses for repair billing lines: pending, ready, on_hold, rejected, invoiced, paid, cancelled, credited
 * Only accessible by System Administrator.
	 * @returns InvoiceLinePublic Successful Response
	 * @throws ApiError
	 */
	public static updateInvoiceLineStatus(data: TDataUpdateInvoiceLineStatus): CancelablePromise<InvoiceLinePublic> {
		const {
id,
status,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/invoice-lines/{id}/status',
			path: {
				id
			},
			query: {
				status
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Invoice Line Rate
	 * Update invoice line rate and recalculate amount.
 * Only accessible by System Administrator.
	 * @returns InvoiceLinePublic Successful Response
	 * @throws ApiError
	 */
	public static updateInvoiceLineRate(data: TDataUpdateInvoiceLineRate): CancelablePromise<InvoiceLinePublic> {
		const {
id,
rate,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/invoice-lines/{id}/rate',
			path: {
				id
			},
			query: {
				rate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Invoice Line Amount
	 * Update invoice line amount and/or billed amount.
 * Useful for repair billing where amounts may need manual adjustment.
 * Only accessible by System Administrator.
	 * @returns InvoiceLinePublic Successful Response
	 * @throws ApiError
	 */
	public static updateInvoiceLineAmount(data: TDataUpdateInvoiceLineAmount): CancelablePromise<InvoiceLinePublic> {
		const {
amount,
billedAmount,
id,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/invoice-lines/{id}/amount',
			path: {
				id
			},
			query: {
				amount, billed_amount: billedAmount
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Pay Invoice Line
	 * Mark invoice line as paid and update invoice status accordingly.
 * Only accessible by System Administrator.
	 * @returns InvoiceLinePublic Successful Response
	 * @throws ApiError
	 */
	public static payInvoiceLine(data: TDataPayInvoiceLine): CancelablePromise<InvoiceLinePublic> {
		const {
id,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/invoices/invoice-lines/{id}/pay',
			path: {
				id
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Invoice To Xero
	 * Generate invoices for all invoice lines with status 'ready'.
 * This will send to Xero, create invoice records in WyseHub, and update status to 'invoiced'.
 * Invoice lines are grouped by supplier (partner_id from related referral allocations).
 * Supports both regular invoice lines (type='invoice') and repair billing lines (type='repair_billing').
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateInvoiceToXero(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-invoice',
		});
	}

	/**
	 * Get Invoice Request Lines
	 * Retrieve invoice request lines with optional status filter.
 * Only accessible by System Administrator.
 * Valid statuses: pending, ready, on_hold, rejected, requested
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getInvoiceRequestLines(data: TDataGetInvoiceRequestLines = {}): CancelablePromise<Record<string, unknown>> {
		const {
limit = 100,
skip = 0,
status,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/invoice-request-lines',
			query: {
				status, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Pending Request Lines By Supplier
	 * Retrieve pending, ready, and on hold invoice request lines grouped by supplier/partner.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getPendingRequestLinesBySupplier(data: TDataGetPendingRequestLinesBySupplier = {}): CancelablePromise<Record<string, unknown>> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/pending-request-lines-by-supplier',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Invoice Request Pdf
	 * Create an invoice request for a single request line and update status to 'requested'.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateInvoiceRequestPdf(data: TDataGenerateInvoiceRequestPdf): CancelablePromise<Record<string, unknown>> {
		const {
lineId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-invoice-request-pdf/{line_id}',
			path: {
				line_id: lineId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Api Usage Billing Lines Direct
	 * Generate API usage billing lines for all partners with active billing configurations.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateApiUsageBillingLinesDirect(data: TDataGenerateApiUsageBillingLinesDirect): CancelablePromise<Record<string, unknown>> {
		const {
billingDate,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-api-usage-billing-lines',
			query: {
				billing_date: billingDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Partner Api Usage Billing Direct
	 * Generate API usage billing for a specific partner.
 * If generate_invoice is True (default), will also create the invoice immediately.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generatePartnerApiUsageBillingDirect(data: TDataGeneratePartnerApiUsageBillingDirect): CancelablePromise<Record<string, unknown>> {
		const {
billingDate,
generateInvoice = true,
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-partner-api-usage-billing/{partner_id}',
			path: {
				partner_id: partnerId
			},
			query: {
				billing_date: billingDate, generate_invoice: generateInvoice
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Api Usage Billing Summary All
	 * Get API usage billing summary.
 *
 * If a partner_id is provided as a query parameter, return that partner's
 * summary; otherwise return an empty summary payload.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getApiUsageBillingSummaryAll(data: TDataGetApiUsageBillingSummaryAll = {}): CancelablePromise<Record<string, unknown>> {
		const {
endDate,
partnerId,
startDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/api-usage-billing-summary',
			query: {
				partner_id: partnerId, start_date: startDate, end_date: endDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Api Usage Billing Summary
	 * Get API usage billing summary for a partner.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getApiUsageBillingSummary(data: TDataGetApiUsageBillingSummary): CancelablePromise<Record<string, unknown>> {
		const {
endDate,
partnerId,
startDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/api-usage-billing-summary/{partner_id}',
			path: {
				partner_id: partnerId
			},
			query: {
				start_date: startDate, end_date: endDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Generate Api Usage Invoices
	 * Generate invoices for all API usage billing lines with status 'pending'.
 * This will create invoices in WyseHub and Xero for API usage billing.
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static generateApiUsageInvoices(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/invoices/generate-api-usage-invoices',
		});
	}

	/**
	 * Get Xero Online Invoice Url
	 * Get the Xero online invoice URL for an invoice.
 * Requires the invoice to have a xero_invoice_id.
 * Note: This URL is now automatically fetched and stored in file_location when creating invoices.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getXeroOnlineInvoiceUrl(data: TDataGetXeroOnlineInvoiceUrl): CancelablePromise<Record<string, unknown>> {
		const {
invoiceId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/invoices/{invoice_id}/xero-online-url',
			path: {
				invoice_id: invoiceId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataGetPartnerApiBillingConfigs = {
                limit?: number
skip?: number

            }
export type TDataCreatePartnerApiBillingConfig = {
                requestBody: PartnerApiBillingConfigCreate

            }
export type TDataGetPartnerApiBillingConfig = {
                partnerId: number

            }
export type TDataUpdatePartnerApiBillingConfig = {
                partnerId: number
requestBody: PartnerApiBillingConfigUpdate

            }
export type TDataDeletePartnerApiBillingConfig = {
                partnerId: number

            }
export type TDataGetApiUsage = {
                billingStatus?: string | null
endDate?: string | null
endpoint?: string | null
limit?: number
partnerId?: number | null
skip?: number
startDate?: string | null

            }
export type TDataUpdateApiUsageBillingStatus = {
                billingStatus: string
usageId: number

            }
export type TDataGetWorkflowBillingLedgerSummary = {
                billingPeriod: string
partnerId: number

            }
export type TDataListWorkflowBillingLedgerEvents = {
                billingPeriod: string
includeEvaluation?: boolean
limit?: number
partnerId: number
skip?: number

            }
export type TDataGetWorkflowRateConfigs = {
                limit?: number
partnerId?: number | null
skip?: number
workflowKey?: string | null

            }
export type TDataCreateWorkflowRateConfig = {
                requestBody: WorkflowRateConfigCreate

            }
export type TDataGetPartnerWorkflowRates = {
                partnerId: number

            }
export type TDataGetWorkflowRateConfig = {
                configId: number

            }
export type TDataUpdateWorkflowRateConfig = {
                configId: number
requestBody: WorkflowRateConfigUpdate

            }
export type TDataDeleteWorkflowRateConfig = {
                configId: number

            }

export class ApiBillingService {

	/**
	 * Get Partner Api Billing Configs
	 * Get all partner API billing configurations.
	 * @returns PartnerApiBillingConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static getPartnerApiBillingConfigs(data: TDataGetPartnerApiBillingConfigs = {}): CancelablePromise<PartnerApiBillingConfigsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/partner-configs',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Partner Api Billing Config
	 * Create API billing configuration for a partner.
	 * @returns PartnerApiBillingConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createPartnerApiBillingConfig(data: TDataCreatePartnerApiBillingConfig): CancelablePromise<PartnerApiBillingConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/api-billing/partner-configs',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Partner Api Billing Config
	 * Get API billing configuration for a specific partner.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getPartnerApiBillingConfig(data: TDataGetPartnerApiBillingConfig): CancelablePromise<PartnerApiBillingConfigPublic | Record<string, unknown>> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/partner-configs/{partner_id}',
			path: {
				partner_id: partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Partner Api Billing Config
	 * Update API billing configuration for a partner.
	 * @returns PartnerApiBillingConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updatePartnerApiBillingConfig(data: TDataUpdatePartnerApiBillingConfig): CancelablePromise<PartnerApiBillingConfigPublic> {
		const {
partnerId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/api-billing/partner-configs/{partner_id}',
			path: {
				partner_id: partnerId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Partner Api Billing Config
	 * Delete API billing configuration for a partner.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deletePartnerApiBillingConfig(data: TDataDeletePartnerApiBillingConfig): CancelablePromise<Record<string, string>> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/api-billing/partner-configs/{partner_id}',
			path: {
				partner_id: partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Api Usage
	 * Get API usage records from RequestLog with optional filtering.
	 * @returns RequestLogsPublic Successful Response
	 * @throws ApiError
	 */
	public static getApiUsage(data: TDataGetApiUsage = {}): CancelablePromise<RequestLogsPublic> {
		const {
billingStatus,
endDate,
endpoint,
limit = 100,
partnerId,
skip = 0,
startDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/usage',
			query: {
				partner_id: partnerId, endpoint, billing_status: billingStatus, start_date: startDate, end_date: endDate, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Api Usage Billing Status
	 * Update billing status of an API usage record.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static updateApiUsageBillingStatus(data: TDataUpdateApiUsageBillingStatus): CancelablePromise<Record<string, string>> {
		const {
billingStatus,
usageId,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/api-billing/usage/{usage_id}/billing-status',
			path: {
				usage_id: usageId
			},
			query: {
				billing_status: billingStatus
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow Billing Ledger Summary
	 * Aggregate workflow billing ledger rows for a partner and billing month.
 *
 * Mirrors Annie/API usage summaries on the admin billing page: counts billable
 * (non-evaluation) runs by status. Evaluation-mode runs are counted separately.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getWorkflowBillingLedgerSummary(data: TDataGetWorkflowBillingLedgerSummary): CancelablePromise<Record<string, unknown>> {
		const {
billingPeriod,
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/workflow-ledger/summary',
			query: {
				partner_id: partnerId, billing_period: billingPeriod
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Workflow Billing Ledger Events
	 * Paginated workflow billing ledger rows for the admin billing UI.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listWorkflowBillingLedgerEvents(data: TDataListWorkflowBillingLedgerEvents): CancelablePromise<Record<string, unknown>> {
		const {
billingPeriod,
includeEvaluation = false,
limit = 50,
partnerId,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/workflow-ledger/events',
			query: {
				partner_id: partnerId, billing_period: billingPeriod, skip, limit, includeEvaluation
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow Rate Configs
	 * Get workflow rate configurations.
 * Optionally filter by partner_id and/or workflow_key.
	 * @returns WorkflowRateConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static getWorkflowRateConfigs(data: TDataGetWorkflowRateConfigs = {}): CancelablePromise<WorkflowRateConfigsPublic> {
		const {
limit = 100,
partnerId,
skip = 0,
workflowKey,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/workflow-rates',
			query: {
				partner_id: partnerId, workflow_key: workflowKey, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Workflow Rate Config
	 * Create a new workflow rate configuration for a partner.
	 * @returns WorkflowRateConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createWorkflowRateConfig(data: TDataCreateWorkflowRateConfig): CancelablePromise<WorkflowRateConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/api-billing/workflow-rates',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Partner Workflow Rates
	 * Get all workflow rates for a specific partner.
	 * @returns WorkflowRateConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static getPartnerWorkflowRates(data: TDataGetPartnerWorkflowRates): CancelablePromise<WorkflowRateConfigsPublic> {
		const {
partnerId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/workflow-rates/partner/{partner_id}',
			path: {
				partner_id: partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow Rate Config
	 * Get a specific workflow rate configuration.
	 * @returns WorkflowRateConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static getWorkflowRateConfig(data: TDataGetWorkflowRateConfig): CancelablePromise<WorkflowRateConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/api-billing/workflow-rates/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Workflow Rate Config
	 * Update a workflow rate configuration.
	 * @returns WorkflowRateConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updateWorkflowRateConfig(data: TDataUpdateWorkflowRateConfig): CancelablePromise<WorkflowRateConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/api-billing/workflow-rates/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Workflow Rate Config
	 * Delete a workflow rate configuration.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteWorkflowRateConfig(data: TDataDeleteWorkflowRateConfig): CancelablePromise<Record<string, string>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/api-billing/workflow-rates/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataTriggerRepairBilling = {
                /**
 * End date in YYYY-MM-DD format
 */
endDate: string
/**
 * Optional partner ID filter
 */
partnerId?: number | null
/**
 * Start date in YYYY-MM-DD format
 */
startDate: string

            }
export type TDataGetEligibleRepairs = {
                /**
 * End date filter (YYYY-MM-DD)
 */
endDate?: string | null
/**
 * Include already billed repairs
 */
includeBilled?: boolean
/**
 * Partner ID filter
 */
partnerId?: number | null
/**
 * Start date filter (YYYY-MM-DD)
 */
startDate?: string | null

            }
export type TDataGetRepairAllocationBillingStatus = {
                allocationId: number

            }

export class RepairBillingService {

	/**
	 * Trigger Repair Billing
	 * Trigger repair billing for specific date ranges.
 *
 * Creates invoice lines for repair allocations with invoice dates in the specified range.
 * Only accessible by superuser.
 *
 * Args:
 * start_date: Start date for repair_invoice_date filter (YYYY-MM-DD)
 * end_date: End date for repair_invoice_date filter (YYYY-MM-DD)
 * partner_id: Optional partner ID to filter repairs
 *
 * Returns:
 * Summary of repairs processed and invoice lines created
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static triggerRepairBilling(data: TDataTriggerRepairBilling): CancelablePromise<Record<string, unknown>> {
		const {
endDate,
partnerId,
startDate,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/repair-billing/trigger',
			query: {
				start_date: startDate, end_date: endDate, partner_id: partnerId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Eligible Repairs
	 * Get repair allocations eligible for billing.
 *
 * Returns repairs with invoice dates that can be processed for billing.
 * Only accessible by superuser.
 *
 * Args:
 * start_date: Optional start date filter for repair_invoice_date
 * end_date: Optional end date filter for repair_invoice_date
 * partner_id: Optional partner ID filter
 * include_billed: Whether to include already billed repairs
 *
 * Returns:
 * List of eligible repair allocations with billing status
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getEligibleRepairs(data: TDataGetEligibleRepairs = {}): CancelablePromise<Record<string, unknown>> {
		const {
endDate,
includeBilled = false,
partnerId,
startDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/repair-billing/eligible-repairs',
			query: {
				start_date: startDate, end_date: endDate, partner_id: partnerId, include_billed: includeBilled
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Repair Allocation Billing Status
	 * Get the current billing status for a repair allocation.
 *
 * Returns detailed information about the billing state including:
 * - Whether the allocation is a repair
 * - Current billing status (unbilled, pending, ready, invoiced, paid, etc.)
 * - Associated invoice line information
 * - Repair invoice date
 *
 * Only accessible by System Administrator.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getRepairAllocationBillingStatus(data: TDataGetRepairAllocationBillingStatus): CancelablePromise<Record<string, unknown>> {
		const {
allocationId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/repair-billing/repair-allocations/{allocation_id}/billing-status',
			path: {
				allocation_id: allocationId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}



export class DbProfilerService {

	/**
	 * Get Profiler Stats
	 * Get database query profiler statistics.
	 * @returns ProfilerStats Successful Response
	 * @throws ApiError
	 */
	public static getProfilerStats(): CancelablePromise<ProfilerStats> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/db-profiler/stats',
		});
	}

	/**
	 * Enable Profiler
	 * Enable database query profiling.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static enableProfiler(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/db-profiler/enable/',
		});
	}

	/**
	 * Disable Profiler
	 * Disable database query profiling.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static disableProfiler(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/db-profiler/disable/',
		});
	}

	/**
	 * Reset Profiler
	 * Reset all profiler statistics.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static resetProfiler(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/db-profiler/reset/',
		});
	}

}

export type TDataUploadEdgeCsv = {
                formData: Body_edge_import_upload_edge_csv

            }
export type TDataGetEdgeImportStatus = {
                taskId: string

            }

export class EdgeImportService {

	/**
	 * Upload Edge Csv
	 * Upload an Edge CSV/Excel file for processing referral allocations.
 *
 * This endpoint accepts CSV or Excel files exported from the Edge system and processes
 * them using the referral allocation import system. The file is temporarily saved
 * and then processed asynchronously by a Celery task.
 *
 * Args:
 * current_user: The authenticated user (must be superuser)
 * partner_id: The partner ID to associate with all allocations
 * file: The CSV/Excel file to process
 *
 * Returns:
 * Dictionary with task ID and status information
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static uploadEdgeCsv(data: TDataUploadEdgeCsv): CancelablePromise<unknown> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/edge-import/edge-csv-upload/',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Edge Import Status
	 * Check the status of an Edge CSV/Excel import task.
 *
 * Args:
 * task_id: The Celery task ID returned from the upload endpoint
 * current_user: The authenticated user
 *
 * Returns:
 * Dictionary with task status information
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getEdgeImportStatus(data: TDataGetEdgeImportStatus): CancelablePromise<unknown> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/edge-import/edge-import-status/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataCreateAccessRequest = {
                requestBody: AccessRequestData

            }

export class AccessRequestsService {

	/**
	 * Create Access Request
	 * Submit an access request.
 *
 * This endpoint processes access requests from the public Annie page
 * and sends a notification email to administrators.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createAccessRequest(data: TDataCreateAccessRequest): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/access-requests/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataXeroSeed = {
                requestBody: XeroSeedRequest

            }
export type TDataXeroCallback = {
                code?: string | null
state?: string | null

            }
export type TDataSwitchXeroCompany = {
                requestBody: SwitchCompanyRequest

            }

export class XeroService {

	/**
	 * Xero Seed
	 * Seed Redis with a known refresh_token and tenant_id without interactive login.
 *
 * This is useful if you already have a refresh_token from a prior consent and want a
 * backend-only flow. We verify the token by exchanging it for an access token once and
 * store the payload in Redis with an expiry.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static xeroSeed(data: TDataXeroSeed): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/xero/seed',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Xero Login
	 * Redirect the superuser to Xero for OAuth authorization.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static xeroLogin(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/xero/login',
		});
	}

	/**
	 * Xero Callback
	 * Handle Xero OAuth callback, exchange code, store tokens and tenant in Redis.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static xeroCallback(data: TDataXeroCallback = {}): CancelablePromise<Record<string, unknown>> {
		const {
code,
state,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/xero/callback/',
			query: {
				code, state
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Xero Status
	 * Return whether we have Xero tokens in Redis and tenant id.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static xeroStatus(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/xero/status',
		});
	}

	/**
	 * Xero Logout
	 * Remove Xero tokens from Redis.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static xeroLogout(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/xero/logout',
		});
	}

	/**
	 * List Xero Companies
	 * List all available Xero companies/organizations for the authenticated user.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static listXeroCompanies(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/xero/companies',
		});
	}

	/**
	 * Switch Xero Company
	 * Switch to a different Xero company/organization.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static switchXeroCompany(data: TDataSwitchXeroCompany): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/xero/switch-company',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Xero Webhook
	 * Receive Xero webhook notifications.
 *
 * Xero sends webhook notifications for various events like:
 * - Invoice created, updated, or deleted
 * - Contact created, updated, or deleted
 * - Payment created, updated, or deleted
 * - And other accounting events
 *
 * For now, we'll store all webhook data in the RequestLog table for analysis.
 * Once we understand the webhook payloads and timing, we can implement
 * specific handling for different event types.
 *
 * Reference: https://developer.xero.com/documentation/guides/webhooks/overview/
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static xeroWebhook(): CancelablePromise<Record<string, string>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/xero/webhook/',
		});
	}

}

export type TDataListBatchPostprocessors = {
                nameContains?: string | null

            }
export type TDataCreatePromptConfig = {
                requestBody: AIPromptConfigCreate

            }
export type TDataGetPromptHistory = {
                agentKey?: string | null
model: string
variant?: string

            }
export type TDataGetAiPromptConfig = {
                model: string
version: string

            }
export type TDataUpdatePromptConfig = {
                configId: number
requestBody: AIPromptConfigUpdate

            }
export type TDataDeletePromptConfig = {
                configId: number

            }
export type TDataCreatePromptDraft = {
                requestBody: AIPromptRevisionCreate

            }
export type TDataUpdatePromptDraft = {
                configId: number
requestBody: AIPromptDraftUpdate

            }
export type TDataPromotePromptDraft = {
                configId: number

            }
export type TDataRetirePromptConfig = {
                configId: number

            }

export class AiPromptConfigsService {

	/**
	 * List Batch Postprocessors
	 * List ai_prompt_configs eligible for post-batch processing.
 *
 * Eligibility is data-driven: rows with non-null batch_runner_spec and is_active.
	 * @returns BatchPostprocessorOptions Successful Response
	 * @throws ApiError
	 */
	public static listBatchPostprocessors(data: TDataListBatchPostprocessors = {}): CancelablePromise<BatchPostprocessorOptions> {
		const {
nameContains,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/ai-prompt-configs/batch-postprocessors',
			query: {
				name_contains: nameContains
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Ai Prompt Configs
	 * List all AI prompt configurations.
 *
 * Requires authentication.
	 * @returns AIPromptConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static listAiPromptConfigs(): CancelablePromise<AIPromptConfigsPublic> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/ai-prompt-configs/',
		});
	}

	/**
	 * Create Prompt Config
	 * Create a new AI prompt configuration.
 *
 * Requires superuser privileges.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createPromptConfig(data: TDataCreatePromptConfig): CancelablePromise<AIPromptConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/ai-prompt-configs/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Ai Prompt Slots Route
	 * List prompt slots grouped by (agent_key, variant, model).
	 * @returns AIPromptSlotsPublic Successful Response
	 * @throws ApiError
	 */
	public static listAiPromptSlotsRoute(): CancelablePromise<AIPromptSlotsPublic> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/ai-prompt-configs/slots',
		});
	}

	/**
	 * Get Prompt History
	 * Get revision history for a single prompt slot.
	 * @returns AIPromptConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static getPromptHistory(data: TDataGetPromptHistory): CancelablePromise<AIPromptConfigsPublic> {
		const {
agentKey,
model,
variant = 'default',
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/ai-prompt-configs/history',
			query: {
				model, variant, agent_key: agentKey
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Ai Prompt Config
	 * Get AI prompt configuration by version and model.
 *
 * Requires authentication.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static getAiPromptConfig(data: TDataGetAiPromptConfig): CancelablePromise<AIPromptConfigPublic> {
		const {
model,
version,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/ai-prompt-configs/{version}/{model}',
			path: {
				version, model
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Prompt Config
	 * Update an AI prompt configuration.
 *
 * Requires superuser privileges.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updatePromptConfig(data: TDataUpdatePromptConfig): CancelablePromise<AIPromptConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/ai-prompt-configs/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Prompt Config
	 * Delete an AI prompt configuration (soft delete by setting is_active=False).
 *
 * Requires superuser privileges.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deletePromptConfig(data: TDataDeletePromptConfig): CancelablePromise<Record<string, unknown>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/ai-prompt-configs/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Prompt Draft
	 * Create a draft revision (brand-new or cloned from an existing prompt).
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createPromptDraft(data: TDataCreatePromptDraft): CancelablePromise<AIPromptConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/ai-prompt-configs/drafts',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Prompt Draft
	 * Edit an existing draft revision.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updatePromptDraft(data: TDataUpdatePromptDraft): CancelablePromise<AIPromptConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/ai-prompt-configs/drafts/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Promote Prompt Draft
	 * Promote a draft revision to live immediately.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static promotePromptDraft(data: TDataPromotePromptDraft): CancelablePromise<AIPromptConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/ai-prompt-configs/drafts/{config_id}/promote',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Retire Prompt Config
	 * Retire a prompt revision.
	 * @returns AIPromptConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static retirePromptConfig(data: TDataRetirePromptConfig): CancelablePromise<AIPromptConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/ai-prompt-configs/{config_id}/retire',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListReportTemplates = {
                activeOnly?: boolean

            }
export type TDataCreateReportTemplate = {
                requestBody: ReportTemplateCreate

            }
export type TDataGetReportTemplate = {
                templateId: number

            }
export type TDataUpdateReportTemplate = {
                requestBody: ReportTemplateUpdate
templateId: number

            }
export type TDataDeleteReportTemplate = {
                templateId: number

            }
export type TDataDuplicateReportTemplate = {
                templateId: number

            }
export type TDataPreviewReportTemplatePdf = {
                templateId: number

            }
export type TDataPreviewReportTemplate = {
                batchLayout?: boolean
channel?: string
templateId: number

            }

export class ReportTemplatesService {

	/**
	 * List Report Templates
	 * List all report templates. Authenticated users only.
	 * @returns ReportTemplatesPublic Successful Response
	 * @throws ApiError
	 */
	public static listReportTemplates(data: TDataListReportTemplates = {}): CancelablePromise<ReportTemplatesPublic> {
		const {
activeOnly = true,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/report-templates/',
			query: {
				active_only: activeOnly
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Report Template
	 * Create a new report template. Superuser only.
	 * @returns ReportTemplatePublic Successful Response
	 * @throws ApiError
	 */
	public static createReportTemplate(data: TDataCreateReportTemplate): CancelablePromise<ReportTemplatePublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/report-templates/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Report Template
	 * Get a single report template by ID.
	 * @returns ReportTemplatePublic Successful Response
	 * @throws ApiError
	 */
	public static getReportTemplate(data: TDataGetReportTemplate): CancelablePromise<ReportTemplatePublic> {
		const {
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/report-templates/{template_id}',
			path: {
				template_id: templateId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Report Template
	 * Update an existing report template. Superuser only.
	 * @returns ReportTemplatePublic Successful Response
	 * @throws ApiError
	 */
	public static updateReportTemplate(data: TDataUpdateReportTemplate): CancelablePromise<ReportTemplatePublic> {
		const {
requestBody,
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/report-templates/{template_id}',
			path: {
				template_id: templateId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Report Template
	 * Soft-delete a report template (sets is_active=False). Superuser only.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteReportTemplate(data: TDataDeleteReportTemplate): CancelablePromise<Record<string, unknown>> {
		const {
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/report-templates/{template_id}',
			path: {
				template_id: templateId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Duplicate Report Template
	 * Duplicate an existing template. Superuser only.
	 * @returns ReportTemplatePublic Successful Response
	 * @throws ApiError
	 */
	public static duplicateReportTemplate(data: TDataDuplicateReportTemplate): CancelablePromise<ReportTemplatePublic> {
		const {
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/report-templates/{template_id}/duplicate',
			path: {
				template_id: templateId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Preview Report Template Pdf
	 * Render the PDF template with mock data through WeasyPrint (same path as scheduled PDFs).
	 * @returns any Successful Response
	 * @throws ApiError
	 */
	public static previewReportTemplatePdf(data: TDataPreviewReportTemplatePdf): CancelablePromise<any> {
		const {
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/report-templates/{template_id}/preview/pdf',
			path: {
				template_id: templateId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Preview Report Template
	 * Render a template against mock data and return the result.
 *
 * ``channel`` can be ``email`` (default) or ``pdf``.
 * Returns ``{"subject": "...", "html": "..."}`` for email,
 * or ``{"html": "..."}`` for PDF (HTML before WeasyPrint).
 *
 * When ``batch_layout`` is true and ``channel`` is ``email``, the HTML matches the
 * scheduled batch email: metrics prelude + one claim card + footer (same as
 * ``email_prepend_metrics`` on).
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static previewReportTemplate(data: TDataPreviewReportTemplate): CancelablePromise<Record<string, unknown>> {
		const {
batchLayout = false,
channel = 'email',
templateId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/report-templates/{template_id}/preview',
			path: {
				template_id: templateId
			},
			query: {
				channel, batch_layout: batchLayout
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataMonitoringGetRateLimitMetrics = {
                /**
 * Hours of data to include (1-168)
 */
hours?: number

            }
export type TDataMonitoringGetRateLimitStatistics = {
                /**
 * Days of data to analyze (1-30)
 */
days?: number

            }

export class RateLimitingService {

	/**
	 * Get Rate Limit Health
	 * Get comprehensive health status of the rate limiting system.
 *
 * This endpoint provides detailed health information about all rate limiting
 * components including Redis, database, configuration, and audit logging.
 *
 * Requires superuser privileges for security.
 *
 * Returns:
 * Dictionary with health status of all components
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetRateLimitHealth(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/health',
		});
	}

	/**
	 * Get Rate Limit Metrics
	 * Get comprehensive rate limiting metrics for monitoring dashboards.
 *
 * This endpoint provides detailed metrics about rate limiting performance,
 * usage patterns, and system health over a specified time period.
 *
 * Args:
 * hours: Number of hours of historical data to include (1-168 hours)
 *
 * Returns:
 * Dictionary with comprehensive rate limiting metrics
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetRateLimitMetrics(data: TDataMonitoringGetRateLimitMetrics = {}): CancelablePromise<Record<string, unknown>> {
		const {
hours = 24,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/metrics',
			query: {
				hours
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Rate Limit Alerts
	 * Get current rate limiting alerts and warnings.
 *
 * This endpoint checks for various alert conditions including high activity,
 * low success rates, Redis issues, and suspicious patterns.
 *
 * Returns:
 * Dictionary with current alerts and their severity levels
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetRateLimitAlerts(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/alerts',
		});
	}

	/**
	 * Get Rate Limit Statistics
	 * Get detailed rate limiting statistics and trends.
 *
 * This endpoint provides comprehensive statistical analysis of rate limiting
 * patterns, trends, and performance over a specified time period.
 *
 * Args:
 * days: Number of days of historical data to analyze (1-30 days)
 *
 * Returns:
 * Dictionary with detailed statistical analysis
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetRateLimitStatistics(data: TDataMonitoringGetRateLimitStatistics = {}): CancelablePromise<Record<string, unknown>> {
		const {
days = 7,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/statistics',
			query: {
				days
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Redis Status
	 * Get detailed Redis status for rate limiting operations.
 *
 * This endpoint provides comprehensive information about Redis health,
 * performance, and rate limiting key statistics.
 *
 * Returns:
 * Dictionary with Redis status and performance metrics
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetRedisStatus(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/redis-status',
		});
	}

	/**
	 * Force Cleanup
	 * Force cleanup of expired rate limiting data.
 *
 * This endpoint manually triggers cleanup of expired rate limiting entries
 * in Redis to free up memory and maintain performance.
 *
 * Requires superuser privileges.
 *
 * Returns:
 * Dictionary with cleanup results
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringForceCleanup(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/rate-limiting/cleanup',
		});
	}

	/**
	 * Get Dashboard Data
	 * Get comprehensive dashboard data for rate limiting monitoring.
 *
 * This endpoint provides all the data needed for a monitoring dashboard
 * including real-time metrics, health status, alerts, and trends.
 *
 * Returns:
 * Dictionary with comprehensive dashboard data
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static monitoringGetDashboardData(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/rate-limiting/dashboard-data',
		});
	}

}

export type TDataAdminResetUserRateLimit = {
                /**
 * Optional resource name to reset (defaults to all known user resources)
 */
resource?: string | null
/**
 * User ID to reset
 */
userId: number

            }
export type TDataAdminResetIpRateLimit = {
                /**
 * Client IP address to reset (as shown in request logs)
 */
ipAddress: string
/**
 * Optional resource name to reset (defaults to all known IP resources)
 */
resource?: string | null

            }
export type TDataAdminUpdateLlmCostCap = {
                /**
 * Daily cap in USD
 */
capUsd: number

            }
export type TDataAdminReadRateLimitConfigs = {
                limit?: number
skip?: number

            }
export type TDataCreateRateLimitConfigEndpoint = {
                requestBody: RateLimitConfigCreate

            }
export type TDataReadRateLimitConfig = {
                configId: number

            }
export type TDataUpdateRateLimitConfigEndpoint = {
                configId: number
requestBody: RateLimitConfigUpdate

            }
export type TDataDeleteRateLimitConfigEndpoint = {
                configId: number

            }
export type TDataReadRateLimitConfigByEndpoint = {
                endpointPath: string
/**
 * HTTP method (GET, POST, PUT, DELETE, etc.)
 */
method: string

            }
export type TDataAdminReadBulkOperationConfigs = {
                limit?: number
skip?: number

            }
export type TDataCreateBulkOperationConfigEndpoint = {
                requestBody: BulkOperationConfigCreate

            }
export type TDataReadBulkOperationConfig = {
                configId: number

            }
export type TDataUpdateBulkOperationConfigEndpoint = {
                configId: number
requestBody: BulkOperationConfigUpdate

            }
export type TDataDeleteBulkOperationConfigEndpoint = {
                configId: number

            }
export type TDataReadBulkOperationConfigByName = {
                configName: string

            }
export type TDataUpdateCacheTtl = {
                /**
 * Cache TTL in seconds (60-3600)
 */
ttlSeconds: number

            }
export type TDataGetEndpointAnalytics = {
                /**
 * Hours to analyze (1-168)
 */
hours?: number
/**
 * Number of top endpoints to return
 */
topN?: number

            }
export type TDataGetRequestLogs = {
                /**
 * Filter by specific endpoint
 */
endpoint?: string
/**
 * Hours to look back
 */
hours?: number
/**
 * Maximum number of logs to return
 */
limit?: number
/**
 * Filter by HTTP method
 */
method?: string
/**
 * Show only rate limited requests
 */
rateLimitedOnly?: boolean

            }
export type TDataExportAnalyticsData = {
                format?: string
hours?: number

            }
export type TDataReadTableRows = {
                limit?: number
search?: string
skip?: number
sortBy?: string | null
sortOrder?: string
tableName: string

            }
export type TDataCreateTableRow = {
                requestBody: Record<string, unknown>
tableName: string

            }
export type TDataReadTableRow = {
                rowId: unknown
tableName: string

            }
export type TDataUpdateTableRow = {
                requestBody: Record<string, unknown>
rowId: unknown
tableName: string

            }
export type TDataDeleteTableRow = {
                rowId: unknown
tableName: string

            }

export class AdministrationService {

	/**
	 * Reset User Rate Limit
	 * Reset Redis-backed rate limits for a specific user ID.
 *
 * If no resource is provided, this clears all known USER/PATH_USER resources.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminResetUserRateLimit(data: TDataAdminResetUserRateLimit): CancelablePromise<Record<string, unknown>> {
		const {
resource,
userId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/rate-limit/reset-user',
			query: {
				user_id: userId, resource
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Reset Ip Rate Limit
	 * Reset Redis-backed rate limits for a specific client IP address.
 *
 * If no resource is provided, this clears all known IP-scoped resources.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminResetIpRateLimit(data: TDataAdminResetIpRateLimit): CancelablePromise<Record<string, unknown>> {
		const {
ipAddress,
resource,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/rate-limit/reset-ip',
			query: {
				ip_address: ipAddress, resource
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Llm Cost Cap
	 * Get the daily LLM API cost cap (USD) and current usage.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminGetLlmCostCap(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/llm-cost-cap',
		});
	}

	/**
	 * Update Llm Cost Cap
	 * Update the daily LLM API cost cap (USD). Set to 0 to disable.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminUpdateLlmCostCap(data: TDataAdminUpdateLlmCostCap): CancelablePromise<Record<string, unknown>> {
		const {
capUsd,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/admin/llm-cost-cap',
			query: {
				cap_usd: capUsd
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Configuration Summary
	 * Get a summary of current rate limiting configuration.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminGetConfigurationSummary(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/config/summary',
		});
	}

	/**
	 * Validate Configuration
	 * Validate current rate limiting configuration.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static adminValidateConfiguration(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/config/validate',
		});
	}

	/**
	 * Reload Configuration
	 * Reload rate limiting configuration from database.
 *
 * This endpoint triggers a configuration reload in the unified rate limiting system.
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static reloadConfiguration(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/config/reload',
		});
	}

	/**
	 * Seed Default Config
	 * Seed the database with default rate limiting configurations.
 *
 * Creates default configurations for common endpoints if they don't exist.
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static seedDefaultConfig(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/config/seed',
		});
	}

	/**
	 * Read Rate Limit Configs
	 * Retrieve rate limiting configurations.
 *
 * Requires superuser permissions.
	 * @returns RateLimitConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static adminReadRateLimitConfigs(data: TDataAdminReadRateLimitConfigs = {}): CancelablePromise<RateLimitConfigsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/rate-limit-configs/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Rate Limit Config Endpoint
	 * Create new rate limiting configuration.
 *
 * Requires superuser permissions.
	 * @returns RateLimitConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createRateLimitConfigEndpoint(data: TDataCreateRateLimitConfigEndpoint): CancelablePromise<RateLimitConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/rate-limit-configs/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Rate Limit Config
	 * Get rate limiting configuration by ID.
 *
 * Requires superuser permissions.
	 * @returns RateLimitConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static readRateLimitConfig(data: TDataReadRateLimitConfig): CancelablePromise<RateLimitConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/rate-limit-configs/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Rate Limit Config Endpoint
	 * Update rate limiting configuration.
 *
 * Requires superuser permissions.
	 * @returns RateLimitConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updateRateLimitConfigEndpoint(data: TDataUpdateRateLimitConfigEndpoint): CancelablePromise<RateLimitConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/admin/rate-limit-configs/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Rate Limit Config Endpoint
	 * Delete rate limiting configuration.
 *
 * Requires superuser permissions.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteRateLimitConfigEndpoint(data: TDataDeleteRateLimitConfigEndpoint): CancelablePromise<Record<string, string>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/admin/rate-limit-configs/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Rate Limit Config By Endpoint
	 * Get rate limiting configuration by endpoint path and method.
 *
 * Requires superuser permissions.
	 * @returns RateLimitConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static readRateLimitConfigByEndpoint(data: TDataReadRateLimitConfigByEndpoint): CancelablePromise<RateLimitConfigPublic> {
		const {
endpointPath,
method,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/rate-limit-configs/endpoint/{endpoint_path}',
			path: {
				endpoint_path: endpointPath
			},
			query: {
				method
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Bulk Operation Configs
	 * Retrieve bulk operation configurations.
 *
 * Requires superuser permissions.
	 * @returns BulkOperationConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static adminReadBulkOperationConfigs(data: TDataAdminReadBulkOperationConfigs = {}): CancelablePromise<BulkOperationConfigsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/bulk-configs/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Bulk Operation Config Endpoint
	 * Create new bulk operation configuration.
 *
 * Requires superuser permissions.
	 * @returns BulkOperationConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createBulkOperationConfigEndpoint(data: TDataCreateBulkOperationConfigEndpoint): CancelablePromise<BulkOperationConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/bulk-configs/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Bulk Operation Config
	 * Get bulk operation configuration by ID.
 *
 * Requires superuser permissions.
	 * @returns BulkOperationConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static readBulkOperationConfig(data: TDataReadBulkOperationConfig): CancelablePromise<BulkOperationConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/bulk-configs/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Bulk Operation Config Endpoint
	 * Update bulk operation configuration.
 *
 * Requires superuser permissions.
	 * @returns BulkOperationConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updateBulkOperationConfigEndpoint(data: TDataUpdateBulkOperationConfigEndpoint): CancelablePromise<BulkOperationConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/admin/bulk-configs/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Bulk Operation Config Endpoint
	 * Delete bulk operation configuration.
 *
 * Requires superuser permissions.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteBulkOperationConfigEndpoint(data: TDataDeleteBulkOperationConfigEndpoint): CancelablePromise<Record<string, string>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/admin/bulk-configs/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Bulk Operation Config By Name
	 * Get bulk operation configuration by name.
 *
 * Requires superuser permissions.
	 * @returns BulkOperationConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static readBulkOperationConfigByName(data: TDataReadBulkOperationConfigByName): CancelablePromise<BulkOperationConfigPublic> {
		const {
configName,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/bulk-configs/name/{config_name}',
			path: {
				config_name: configName
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Clear Configuration Cache
	 * Clear the configuration cache and force reload from database.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static clearConfigurationCache(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/config/cache/clear',
		});
	}

	/**
	 * Get Cache Status
	 * Get the current configuration cache status.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getCacheStatus(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/config/cache/status',
		});
	}

	/**
	 * Update Cache Ttl
	 * Update the configuration cache TTL (Time To Live).
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateCacheTtl(data: TDataUpdateCacheTtl): CancelablePromise<Record<string, unknown>> {
		const {
ttlSeconds,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/admin/config/cache/ttl',
			query: {
				ttl_seconds: ttlSeconds
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Endpoint Analytics
	 * Get comprehensive endpoint usage analytics for rate limiting management.
 *
 * Returns:
 * - Top endpoints by request count
 * - Rate limiting statistics
 * - Hourly request distribution
 * - Performance metrics
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getEndpointAnalytics(data: TDataGetEndpointAnalytics = {}): CancelablePromise<Record<string, unknown>> {
		const {
hours = 24,
topN = 20,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/analytics/endpoint-usage',
			query: {
				hours, top_n: topN
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Rate Limit Recommendations
	 * Get intelligent recommendations for rate limit adjustments based on usage patterns.
 *
 * Analyzes the last 7 days of request data to identify:
 * - Endpoints with high rate limiting
 * - Potential configuration issues
 * - Suggested adjustments
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getRateLimitRecommendations(): CancelablePromise<Array<Record<string, unknown>>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/analytics/recommendations',
		});
	}

	/**
	 * Get Real Time Stats
	 * Get real-time rate limiting statistics from Prometheus metrics and database.
 *
 * Returns current request rates, active rate limits, and system health.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getRealTimeStats(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/analytics/real-time-stats',
		});
	}

	/**
	 * Get Request Logs
	 * Get detailed request logs for debugging and analysis.
 *
 * Useful for investigating specific rate limiting issues or understanding
 * traffic patterns for particular endpoints.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getRequestLogs(data: TDataGetRequestLogs = {}): CancelablePromise<Record<string, unknown>> {
		const {
endpoint,
hours = 1,
limit = 100,
method,
rateLimitedOnly = false,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/analytics/request-logs',
			query: {
				endpoint, method, rate_limited_only: rateLimitedOnly, hours, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Export Analytics Data
	 * Export comprehensive analytics data for external analysis.
 *
 * Generates a downloadable report containing:
 * - Endpoint usage statistics
 * - Rate limiting events
 * - Performance metrics
 * - Configuration recommendations
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static exportAnalyticsData(data: TDataExportAnalyticsData = {}): CancelablePromise<Record<string, unknown>> {
		const {
format = 'json',
hours = 24,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/analytics/export',
			query: {
				hours, format
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * List Tables
	 * List allowlisted tables available via admin database endpoints.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static listTables(): CancelablePromise<Array<string>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/database/tables',
		});
	}

	/**
	 * Read Table Rows
	 * Retrieve paginated rows for an allowlisted table with redaction and audit logging.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readTableRows(data: TDataReadTableRows): CancelablePromise<Record<string, unknown>> {
		const {
limit = 100,
search = '',
skip = 0,
sortBy,
sortOrder = 'asc',
tableName,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/database/tables/{table_name}',
			path: {
				table_name: tableName
			},
			query: {
				skip, limit, sort_by: sortBy, sort_order: sortOrder, search
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Table Row
	 * Create a new row in an allowlisted table.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static createTableRow(data: TDataCreateTableRow): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
tableName,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/admin/database/tables/{table_name}',
			path: {
				table_name: tableName
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Table Row
	 * Get a single row by ID from an allowlisted table.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readTableRow(data: TDataReadTableRow): CancelablePromise<Record<string, unknown>> {
		const {
rowId,
tableName,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
			path: {
				table_name: tableName, row_id: rowId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Table Row
	 * Update an existing row in an allowlisted table.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static updateTableRow(data: TDataUpdateTableRow): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
rowId,
tableName,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
			path: {
				table_name: tableName, row_id: rowId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Table Row
	 * Delete a row from an allowlisted table.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteTableRow(data: TDataDeleteTableRow): CancelablePromise<Record<string, string>> {
		const {
rowId,
tableName,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
			path: {
				table_name: tableName, row_id: rowId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListAppSettings = {
                limit?: number
skip?: number

            }
export type TDataCreateSetting = {
                requestBody: AppSettingCreate

            }
export type TDataGetAppSettingEndpoint = {
                settingId: number

            }
export type TDataUpdateSetting = {
                requestBody: AppSettingUpdate
settingId: number

            }
export type TDataDeleteSetting = {
                settingId: number

            }
export type TDataValidateSettingByKey = {
                environment: string
key: string

            }

export class SettingsService {

	/**
	 * List App Settings
	 * List application settings for the current environment.
 *
 * Requires superuser permissions.
	 * @returns AppSettingsPublic Successful Response
	 * @throws ApiError
	 */
	public static listAppSettings(data: TDataListAppSettings = {}): CancelablePromise<AppSettingsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/settings/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Setting
	 * Create a new application setting.
 *
 * Requires superuser permissions.
	 * @returns AppSettingPublic Successful Response
	 * @throws ApiError
	 */
	public static createSetting(data: TDataCreateSetting): CancelablePromise<AppSettingPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/settings/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get App Setting Endpoint
	 * Get an application setting by ID.
 *
 * Requires superuser permissions.
	 * @returns AppSettingPublic Successful Response
	 * @throws ApiError
	 */
	public static getAppSettingEndpoint(data: TDataGetAppSettingEndpoint): CancelablePromise<AppSettingPublic> {
		const {
settingId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/settings/{setting_id}',
			path: {
				setting_id: settingId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Setting
	 * Update an application setting.
 *
 * Requires superuser permissions.
	 * @returns AppSettingPublic Successful Response
	 * @throws ApiError
	 */
	public static updateSetting(data: TDataUpdateSetting): CancelablePromise<AppSettingPublic> {
		const {
requestBody,
settingId,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/settings/{setting_id}',
			path: {
				setting_id: settingId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Setting
	 * Delete an application setting.
 *
 * Requires superuser permissions.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteSetting(data: TDataDeleteSetting): CancelablePromise<Record<string, string>> {
		const {
settingId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/settings/{setting_id}',
			path: {
				setting_id: settingId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Validate Setting By Key
	 * Validate a setting exists by key and environment.
 *
 * Requires superuser permissions.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static validateSettingByKey(data: TDataValidateSettingByKey): CancelablePromise<Record<string, unknown>> {
		const {
environment,
key,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/settings/validate/by-key',
			query: {
				key, environment
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataRehydratePrivacyToken = {
                requestBody: PrivacyRehydrateRequest

            }

export class PrivacyService {

	/**
	 * Rehydrate Privacy Token
	 * Resolve a scoped privacy token for approved incident/audit workflows.
	 * @returns PrivacyRehydrateResponse Successful Response
	 * @throws ApiError
	 */
	public static rehydratePrivacyToken(data: TDataRehydratePrivacyToken): CancelablePromise<PrivacyRehydrateResponse> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/privacy/rehydrate',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Purge Expired Privacy Mappings
	 * Admin endpoint to purge expired scoped privacy mappings immediately.
	 * @returns PrivacyPurgeResponse Successful Response
	 * @throws ApiError
	 */
	public static purgeExpiredPrivacyMappings(): CancelablePromise<PrivacyPurgeResponse> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/privacy/purge-expired',
		});
	}

}

export type TDataListMetabaseReportSchedules = {
                limit?: number
skip?: number

            }
export type TDataCreateMetabaseReportScheduleEndpoint = {
                requestBody: MetabaseReportScheduleCreate

            }
export type TDataGetMetabaseReportScheduleEndpoint = {
                scheduleId: number

            }
export type TDataUpdateMetabaseReportScheduleEndpoint = {
                requestBody: MetabaseReportScheduleUpdate
scheduleId: number

            }
export type TDataDeleteMetabaseReportScheduleEndpoint = {
                scheduleId: number

            }

export class MetabaseReportsService {

	/**
	 * List Metabase Report Schedules
	 * @returns MetabaseReportSchedulesPublic Successful Response
	 * @throws ApiError
	 */
	public static listMetabaseReportSchedules(data: TDataListMetabaseReportSchedules = {}): CancelablePromise<MetabaseReportSchedulesPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/metabase-reports/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Metabase Report Schedule Endpoint
	 * @returns MetabaseReportSchedulePublic Successful Response
	 * @throws ApiError
	 */
	public static createMetabaseReportScheduleEndpoint(data: TDataCreateMetabaseReportScheduleEndpoint): CancelablePromise<MetabaseReportSchedulePublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/metabase-reports/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Metabase Report Schedule Endpoint
	 * @returns MetabaseReportSchedulePublic Successful Response
	 * @throws ApiError
	 */
	public static getMetabaseReportScheduleEndpoint(data: TDataGetMetabaseReportScheduleEndpoint): CancelablePromise<MetabaseReportSchedulePublic> {
		const {
scheduleId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/metabase-reports/{schedule_id}',
			path: {
				schedule_id: scheduleId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Metabase Report Schedule Endpoint
	 * @returns MetabaseReportSchedulePublic Successful Response
	 * @throws ApiError
	 */
	public static updateMetabaseReportScheduleEndpoint(data: TDataUpdateMetabaseReportScheduleEndpoint): CancelablePromise<MetabaseReportSchedulePublic> {
		const {
requestBody,
scheduleId,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/metabase-reports/{schedule_id}',
			path: {
				schedule_id: scheduleId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Metabase Report Schedule Endpoint
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteMetabaseReportScheduleEndpoint(data: TDataDeleteMetabaseReportScheduleEndpoint): CancelablePromise<Record<string, string>> {
		const {
scheduleId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/metabase-reports/{schedule_id}',
			path: {
				schedule_id: scheduleId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataListMetabaseReportCatalog = {
                limit?: number
skip?: number

            }
export type TDataCreateMetabaseReportCatalogEndpoint = {
                requestBody: MetabaseReportCatalogCreate

            }
export type TDataGetMetabaseReportCatalogEndpoint = {
                catalogId: number

            }
export type TDataUpdateMetabaseReportCatalogEndpoint = {
                catalogId: number
requestBody: MetabaseReportCatalogUpdate

            }
export type TDataDeleteMetabaseReportCatalogEndpoint = {
                catalogId: number

            }

export class MetabaseReportCatalogService {

	/**
	 * List Metabase Report Catalog
	 * @returns MetabaseReportCatalogsPublic Successful Response
	 * @throws ApiError
	 */
	public static listMetabaseReportCatalog(data: TDataListMetabaseReportCatalog = {}): CancelablePromise<MetabaseReportCatalogsPublic> {
		const {
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/metabase-report-catalog/',
			query: {
				skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Metabase Report Catalog Endpoint
	 * @returns MetabaseReportCatalogPublic Successful Response
	 * @throws ApiError
	 */
	public static createMetabaseReportCatalogEndpoint(data: TDataCreateMetabaseReportCatalogEndpoint): CancelablePromise<MetabaseReportCatalogPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/metabase-report-catalog/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Metabase Report Catalog Endpoint
	 * @returns MetabaseReportCatalogPublic Successful Response
	 * @throws ApiError
	 */
	public static getMetabaseReportCatalogEndpoint(data: TDataGetMetabaseReportCatalogEndpoint): CancelablePromise<MetabaseReportCatalogPublic> {
		const {
catalogId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/metabase-report-catalog/{catalog_id}',
			path: {
				catalog_id: catalogId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Metabase Report Catalog Endpoint
	 * @returns MetabaseReportCatalogPublic Successful Response
	 * @throws ApiError
	 */
	public static updateMetabaseReportCatalogEndpoint(data: TDataUpdateMetabaseReportCatalogEndpoint): CancelablePromise<MetabaseReportCatalogPublic> {
		const {
catalogId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/metabase-report-catalog/{catalog_id}',
			path: {
				catalog_id: catalogId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Metabase Report Catalog Endpoint
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static deleteMetabaseReportCatalogEndpoint(data: TDataDeleteMetabaseReportCatalogEndpoint): CancelablePromise<Record<string, string>> {
		const {
catalogId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/metabase-report-catalog/{catalog_id}',
			path: {
				catalog_id: catalogId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataCreateMetabaseEmbedToken = {
                requestBody: MetabaseEmbedTokenRequest

            }

export class MetabaseEmbedsService {

	/**
	 * List Available Metabase Embeds
	 * @returns MetabaseReportCatalogAvailablePublic Successful Response
	 * @throws ApiError
	 */
	public static listAvailableMetabaseEmbeds(): CancelablePromise<MetabaseReportCatalogAvailablePublic> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/metabase-embeds/available',
		});
	}

	/**
	 * Create Metabase Embed Token
	 * @returns MetabaseEmbedTokenPublic Successful Response
	 * @throws ApiError
	 */
	public static createMetabaseEmbedToken(data: TDataCreateMetabaseEmbedToken): CancelablePromise<MetabaseEmbedTokenPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/metabase-embeds/token',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataRecordPerformanceMetric = {
                requestBody: PerformanceMetric

            }

export class AnalyticsService {

	/**
	 * Record Performance Metric
	 * Record a performance metric from the frontend.
 *
 * This endpoint receives Core Web Vitals and other performance metrics
 * from the frontend performance monitoring system.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static recordPerformanceMetric(data: TDataRecordPerformanceMetric): CancelablePromise<Record<string, unknown>> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/analytics/performance/',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Analytics Health
	 * Health check for analytics service.
	 * @returns string Successful Response
	 * @throws ApiError
	 */
	public static analyticsHealth(): CancelablePromise<Record<string, string>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/analytics/health/',
		});
	}

}

export type TDataReadSecurityTestResults = {
                /**
 * Filter by environment
 */
environment?: string | null
/**
 * Filter from date
 */
fromDate?: string | null
limit?: number
skip?: number
/**
 * Filter by status
 */
status?: string | null
/**
 * Filter by test suite
 */
testSuiteName?: string | null
/**
 * Filter to date
 */
toDate?: string | null

            }
export type TDataCreateTestResult = {
                requestBody: SecurityTestResultCreate

            }
export type TDataReadSecurityTestResult = {
                resultId: string

            }
export type TDataReadSecurityTestSummary = {
                /**
 * Filter by environment
 */
environment?: string | null

            }
export type TDataCleanupOldResults = {
                /**
 * Retention period in days
 */
retentionDays?: number

            }
export type TDataRunSecurityTests = {
                /**
 * Dry run mode
 */
dryRun?: boolean
/**
 * Environment to run tests
 */
environment?: string
testSuite: string

            }

export class SecurityTestsService {

	/**
	 * Read Security Test Results
	 * Retrieve security test results with optional filters.
	 * @returns SecurityTestResultsPublic Successful Response
	 * @throws ApiError
	 */
	public static readSecurityTestResults(data: TDataReadSecurityTestResults = {}): CancelablePromise<SecurityTestResultsPublic> {
		const {
environment,
fromDate,
limit = 100,
skip = 0,
status,
testSuiteName,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/security-tests/results',
			query: {
				skip, limit, environment, test_suite_name: testSuiteName, status, from_date: fromDate, to_date: toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Test Result
	 * Create a new security test result (internal use by test runner).
	 * @returns SecurityTestResultPublic Successful Response
	 * @throws ApiError
	 */
	public static createTestResult(data: TDataCreateTestResult): CancelablePromise<SecurityTestResultPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/security-tests/results',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Security Test Result
	 * Get security test result by ID.
	 * @returns SecurityTestResultPublic Successful Response
	 * @throws ApiError
	 */
	public static readSecurityTestResult(data: TDataReadSecurityTestResult): CancelablePromise<SecurityTestResultPublic> {
		const {
resultId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/security-tests/results/{result_id}',
			path: {
				result_id: resultId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Read Security Test Summary
	 * Get aggregate summary of security test results.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static readSecurityTestSummary(data: TDataReadSecurityTestSummary = {}): CancelablePromise<Record<string, unknown>> {
		const {
environment,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/security-tests/summary',
			query: {
				environment
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Cleanup Old Results
	 * Delete security test results older than retention period (admin only).
 * Default is 3 years (1095 days).
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static cleanupOldResults(data: TDataCleanupOldResults = {}): CancelablePromise<Record<string, unknown>> {
		const {
retentionDays = 1095,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/security-tests/cleanup',
			query: {
				retention_days: retentionDays
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Run Security Tests
	 * Trigger security test suite execution (admin only).
 * This endpoint queues a Celery task for async execution.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static runSecurityTests(data: TDataRunSecurityTests): CancelablePromise<Record<string, unknown>> {
		const {
dryRun = false,
environment = 'staging',
testSuite,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/security-tests/run/{test_suite}',
			path: {
				test_suite: testSuite
			},
			query: {
				environment, dry_run: dryRun
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Check Test Suite Health
	 * Check security test suite health status.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static checkTestSuiteHealth(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/security-tests/health',
		});
	}

}

export type TDataListTaskConfigs = {
                enabled?: boolean | null
limit?: number
skip?: number

            }
export type TDataCreateTaskSchedule = {
                requestBody: TaskScheduleConfigCreate

            }
export type TDataGetTaskConfig = {
                configId: number

            }
export type TDataUpdateTaskSchedule = {
                configId: number
requestBody: TaskScheduleConfigUpdate

            }
export type TDataSchedulerUpdateTaskSchedule = {
                configId: number
requestBody: TaskScheduleConfigUpdate

            }
export type TDataDeleteTaskSchedule = {
                configId: number

            }
export type TDataGetTaskExecutionHistory = {
                limit?: number
skip?: number
status?: string | null
taskScheduleId?: number | null

            }
export type TDataGetExecutionDetail = {
                executionId: number

            }
export type TDataTriggerTaskNow = {
                configId: number

            }
export type TDataPreviewScheduleConfig = {
                configId: number

            }

export class SchedulerService {

	/**
	 * Get Available Tasks
	 * List all available tasks from registry.
 *
 * Returns metadata for all registered tasks including constraints and filters.
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getAvailableTasks(): CancelablePromise<Array<Record<string, unknown>>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/tasks',
		});
	}

	/**
	 * List Task Configs
	 * List all task schedule configurations with optional filters.
 *
 * Query parameters:
 * - skip: Number of records to skip (default: 0)
 * - limit: Maximum records to return (default: 100, max: 1000)
 * - enabled: Filter by enabled status (true/false, optional)
 *
 * Requires admin role.
	 * @returns TaskScheduleConfigsPublic Successful Response
	 * @throws ApiError
	 */
	public static listTaskConfigs(data: TDataListTaskConfigs = {}): CancelablePromise<TaskScheduleConfigsPublic> {
		const {
enabled,
limit = 100,
skip = 0,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/config',
			query: {
				skip, limit, enabled
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create Task Schedule
	 * Create new task schedule configuration.
 *
 * Validates:
 * - Task exists in registry
 * - Schedule frequency is within allowed range
 * - Filter criteria contains only supported fields
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
	 * @returns TaskScheduleConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static createTaskSchedule(data: TDataCreateTaskSchedule): CancelablePromise<TaskScheduleConfigPublic> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/scheduler/config',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Task Config
	 * Get task schedule configuration by ID.
 *
 * Requires admin role.
	 * @returns TaskScheduleConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static getTaskConfig(data: TDataGetTaskConfig): CancelablePromise<TaskScheduleConfigPublic> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/config/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Task Schedule
	 * Update task schedule configuration.
 *
 * Can modify:
 * - enabled: Toggle task on/off
 * - schedule_type, schedule_value: Change schedule
 * - queue_name: Change task queue
 * - email_recipients: Update recipient list
 * - filter_criteria: Modify task-specific filters
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
	 * @returns TaskScheduleConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static updateTaskSchedule(data: TDataUpdateTaskSchedule): CancelablePromise<TaskScheduleConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PATCH',
			url: '/api/v1/scheduler/config/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Task Schedule
	 * Update task schedule configuration.
 *
 * Can modify:
 * - enabled: Toggle task on/off
 * - schedule_type, schedule_value: Change schedule
 * - queue_name: Change task queue
 * - email_recipients: Update recipient list
 * - filter_criteria: Modify task-specific filters
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
	 * @returns TaskScheduleConfigPublic Successful Response
	 * @throws ApiError
	 */
	public static schedulerUpdateTaskSchedule(data: TDataSchedulerUpdateTaskSchedule): CancelablePromise<TaskScheduleConfigPublic> {
		const {
configId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/scheduler/config/{config_id}',
			path: {
				config_id: configId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Task Schedule
	 * Delete task schedule configuration while preserving history.
 *
 * Marks the schedule as deleted and removes it from active use.
 *
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static deleteTaskSchedule(data: TDataDeleteTaskSchedule): CancelablePromise<Record<string, unknown>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/scheduler/config/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Task Execution History
	 * Get task execution history with optional filters.
 *
 * Query parameters:
 * - task_schedule_id: Filter by specific task schedule
 * - status: Filter by status (pending, running, success, failed)
 * - skip: Number of records to skip (default: 0)
 * - limit: Maximum records to return (default: 20, max: 200)
 *
 * Results ordered by most recent first.
 *
 * Requires admin role.
	 * @returns TaskScheduleExecutionsPublic Successful Response
	 * @throws ApiError
	 */
	public static getTaskExecutionHistory(data: TDataGetTaskExecutionHistory = {}): CancelablePromise<TaskScheduleExecutionsPublic> {
		const {
limit = 20,
skip = 0,
status,
taskScheduleId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/history',
			query: {
				task_schedule_id: taskScheduleId, status, skip, limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Execution Detail
	 * Get detailed task execution record by ID.
 *
 * Requires admin role.
	 * @returns TaskScheduleExecutionPublic Successful Response
	 * @throws ApiError
	 */
	public static getExecutionDetail(data: TDataGetExecutionDetail): CancelablePromise<TaskScheduleExecutionPublic> {
		const {
executionId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/history/{execution_id}',
			path: {
				execution_id: executionId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Trigger Task Now
	 * Manually trigger a scheduled task immediately.
 *
 * Creates execution record and enqueues task.
 * Task executes with default/configured parameters.
 *
 * Returns execution ID for tracking status.
 *
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static triggerTaskNow(data: TDataTriggerTaskNow): CancelablePromise<Record<string, unknown>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/scheduler/run-now/{config_id}',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Redbeat Status
	 * Get Redbeat scheduler status and sync info.
 *
 * Returns information about Redbeat configuration and synced tasks.
 *
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getRedbeatStatus(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/scheduler/redbeat-status',
		});
	}

	/**
	 * Preview Schedule Config
	 * Dry-run all enabled exporters for a schedule config without sending email or writing to DB.
 *
 * Uses an empty sample bot payload to exercise PDF, Excel, and CSV exporters
 * based on the config's output_layout_profile.
 *
 * Returns availability flags, sample CSV rows, and any exporter errors.
 *
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static previewScheduleConfig(data: TDataPreviewScheduleConfig): CancelablePromise<Record<string, unknown>> {
		const {
configId,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/scheduler/config/{config_id}/preview',
			path: {
				config_id: configId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Trigger Redbeat Sync
	 * Trigger manual synchronization of Redbeat schedules from database.
 *
 * Requires admin role.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static triggerRedbeatSync(): CancelablePromise<Record<string, unknown>> {
				return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/scheduler/redbeat-sync',
		});
	}

}

export type TDataListWorkflowRuns = {
                fromDate?: string | null
limit?: number
referralId?: number | null
skip?: number
toDate?: string | null

            }
export type TDataGetWorkflowRun = {
                taskId: string

            }

export class WorkflowFeedbackAdminService {

	/**
	 * List Workflow Runs
	 * @returns WorkflowRunsListPublic Successful Response
	 * @throws ApiError
	 */
	public static listWorkflowRuns(data: TDataListWorkflowRuns = {}): CancelablePromise<WorkflowRunsListPublic> {
		const {
fromDate,
limit = 50,
referralId,
skip = 0,
toDate,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/workflow-runs/',
			query: {
				skip, limit, referralId, fromDate, toDate
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Workflow Run
	 * @returns WorkflowRunDetailPublic Successful Response
	 * @throws ApiError
	 */
	public static getWorkflowRun(data: TDataGetWorkflowRun): CancelablePromise<WorkflowRunDetailPublic> {
		const {
taskId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/admin/workflow-runs/{task_id}',
			path: {
				task_id: taskId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export type TDataGetPartnerIssueRollup = {
                agentName?: string | null
fromDate?: string | null
partnerId?: number | null
toDate?: string | null
workflowKey?: string | null

            }
export type TDataExportPartnerIssueCsv = {
                agentName?: string | null
fromDate?: string | null
partnerId?: number | null
toDate?: string | null
workflowKey?: string | null

            }

export class PartnerIssueInsightsService {

	/**
	 * Get Partner Issue Rollup
	 * @returns PartnerIssueRollupPublic Successful Response
	 * @throws ApiError
	 */
	public static getPartnerIssueRollup(data: TDataGetPartnerIssueRollup = {}): CancelablePromise<PartnerIssueRollupPublic> {
		const {
agentName,
fromDate,
partnerId,
toDate,
workflowKey,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partner-issue-insights/rollup',
			query: {
				fromDate, toDate, partnerId, workflowKey, agentName
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Export Partner Issue Csv
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static exportPartnerIssueCsv(data: TDataExportPartnerIssueCsv = {}): CancelablePromise<unknown> {
		const {
agentName,
fromDate,
partnerId,
toDate,
workflowKey,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/partner-issue-insights/export.csv',
			query: {
				fromDate, toDate, partnerId, workflowKey, agentName
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}